import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getAuth, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { getFirestore, collection, addDoc,   writeBatch, getDocs, query, where, doc, updateDoc, orderBy, deleteDoc, limit, onSnapshot } from "firebase/firestore";



import { format, parseISO, isToday, isAfter, isBefore, addDays, set } from 'date-fns';
import { Badge, List, Avatar, Divider, Typography, Alert } from 'antd';
import { BellOutlined, CalendarOutlined, ExclamationCircleOutlined } from '@ant-design/icons';


import { jsPDF } from "jspdf";

import autoTable from "jspdf-autotable";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";


import dayjs from "dayjs";
import './body.css';


import { Eye, Download } from "lucide-react";

const db = getFirestore();

const { Title, Text } = Typography;

const Body = () => {
// Settle Invoice States
const [searchInvoiceNo, setSearchInvoiceNo] = useState("");
const [foundInvoice, setFoundInvoice] = useState(null);
const [settleAmount, setSettleAmount] = useState("");
const [balanceAfterSettle, setBalanceAfterSettle] = useState(0);

  const [eyeExams, setEyeExams] = useState([]);

  useEffect(() => {
    // Listen for invoices
    const qInvoices = query(collection(db, "invoices"), orderBy("createdAt", "desc"));
    const unsubInvoices = onSnapshot(qInvoices, (snapshot) => {
      setInvoices(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    // Listen for patients
    const qPatients = query(collection(db, "patients"), orderBy("createdAt", "desc"));
    const unsubPatients = onSnapshot(qPatients, (snapshot) => {
      setPatients(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    // Listen for eye exams
    const qEyeExams = query(collection(db, "eyeExams"), orderBy("createdAt", "desc"));
    const unsubEyeExams = onSnapshot(qEyeExams, (snapshot) => {
      setEyeExams(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    });

    // Clean up all listeners on unmount
    return () => {
      unsubInvoices();
      unsubPatients();
      unsubEyeExams();
    };
  }, []);








  const [selectedOption, setSelectedOption] = useState("addPatient"); // Default to "home"
  const [userDetails, setUserDetails] = useState(null); // Define userDetails state
  const auth = getAuth(); // Initialize Firebase Auth
  const navigate = useNavigate(); // Initialize navigate
  const db = getFirestore(); // Initialize Firestore



//fetch all the eye exam report
const [eyeExamRecords, setEyeExamRecords] = useState([]);
const [selectedRecord, setSelectedRecord] = useState(null);


//search function in view eye report
const [filterOption, setFilterOption] = useState('all');


const [settleDate, setSettleDate] = useState("");


// Add Patient 
  const [formData, setFormData] = useState({
    name: '',
    dateOfBirth: '',
    sex: '',
    telephoneNo: '', 
    email: '',
    address: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, 'patients'), formData);
      alert('Patient added successfully!');
      // Reset form
      setFormData({
        name: '',
        dateOfBirth: '',
        sex: '',
        telephoneNo: '', 
        email: '',
        address: ''
      });
    } catch (error) {
      console.error('Error adding patient: ', error);
      alert('Error adding patient');
    }
  };



//Fetch all patients

const [patients, setPatients] = useState([]);
const [loading, setLoading] = useState(true);

useEffect(() => {
  const unsubscribe = onSnapshot(collection(db, "patients"), (snapshot) => {
    const patientsData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    setPatients(patientsData);
    setLoading(false);
  }, (error) => {
    console.error("Error fetching patients:", error);
    setLoading(false);
  });

  return () => unsubscribe();
}, []);


// State variables
const [searchTerm, setSearchTerm] = useState("");
const [editingPatient, setEditingPatient] = useState(null);
const [filteredPatients, setFilteredPatients] = useState([]);

// Filter patients based on search term
// Filter patients based on search term
useEffect(() => {
  const term = searchTerm.trim().toLowerCase();

  // If search is empty → show all patients
  if (!term) {
    setFilteredPatients(patients);
    return;
  }

  const filtered = patients.filter((patient) => {
    const name = patient.name?.toString().toLowerCase() || "";
    const tel = patient.telephoneNo?.toString() || "";
    const mobile = patient.mobileNo?.toString() || "";

    return (
      name.includes(term) ||
      tel.includes(term) ||
      mobile.includes(term)
    );
  });

  setFilteredPatients(filtered);
}, [searchTerm, patients]);

// Handle patient update
const handleUpdatePatient = async (e) => {
  e.preventDefault();
  try {
    const patientRef = doc(db, "patients", editingPatient.id);
    await updateDoc(patientRef, editingPatient);
    setPatients(patients.map(p => p.id === editingPatient.id ? editingPatient : p));
    setEditingPatient(null);
    alert("Patient updated successfully!");
  } catch (error) {
    console.error("Error updating patient: ", error);
    alert("Error updating patient. Please try again.");
  }
};



// Add this function to delete a patient
const handleDeletePatient = async (patientId) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this patient record?");
  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, "patients", patientId));
    setPatients(patients.filter(patient => patient.id !== patientId));
    alert("Patient deleted successfully!");
  } catch (error) {
    console.error("Error deleting patient: ", error);
    alert("Failed to delete patient.");
  }
};




// Export to Excel
const handleDownloadPatients = () => {
  if (filteredPatients.length === 0) {
    alert("No patient data to download.");
    return;
  }
  
  const worksheet = XLSX.utils.json_to_sheet(filteredPatients);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Patients");
  XLSX.writeFile(workbook, "patient_records.xlsx");
};







// STATES

const [to, setTo] = useState("");
const [patientPhoneNo, setPatientPhoneNo] = useState("");
const [deviceType, setDeviceType] = useState("");
const [paymentMethod, setPaymentMethod] = useState("");
const [date, setDate] = useState("");
const [description, setDescription] = useState("");
const [amount, setAmount] = useState("");
const [deductAmount, setDeductAmount] = useState("");
const [totalAmount, setTotalAmount] = useState(0);


// First, organize the dropdown options in A-Z order
const PRODUCT_OPTIONS = [
  "AFO Adult",
  "AFO Pediatric",
  "Back Slab KAFO Pediatric",
  "Black Slab KAFO Adult",
  "DSI Diabetic Shoe Custom Made",
  "EHO Dynamic",
  "EHO Static",
  "FO (EVA) Adult",
  "FO (EVA) Pediatric",
  "FO (Plastic) / SMO (Pediatric)",
  "FO (Plastic) / SMO(Adult)",
  "GRF AFO Adult",
  "GRF AFO Pediatric",
  "Humerus Brace",
  "Humerus / Above Elbow Fracture",
  "Jointed AFO Adult",
  "Jointed AFO Pediatric",
  "KAFO With Side Bars Adult",
  "KAFO With Side Bars Pediatric",
  "KAFO Without Side Bars Adult",
  "KAFO Without Side Bars Pediatric",
  "Partial Foot EVA Slipper With Plastic",
  "Partial Foot EVA Slipper Without Plastic",
  "PTB ORTHOSIS",
  "Silicone Prosthesis",
  "Spinal Orthosis (SO)",
  "TRANSFEMORAL (TF) PROSTHESIS",
  "TRANSTIBIAL (TT) PROSTHESIS",
  "Upper Limb Prosthesis"
];

// Add this new state variable for product selection
const [selectedProduct, setSelectedProduct] = useState("");

// Update invoice number state to start from 1500 and track next number
const [invoiceNumber, setInvoiceNumber] = useState("1500");
const [nextInvoiceNumber, setNextInvoiceNumber] = useState(1501);

// Fetch the latest invoice number when component mounts
useEffect(() => {
  const fetchLatestInvoiceNumber = async () => {
    try {
      const invoicesRef = collection(db, "invoices");
      const q = query(invoicesRef, orderBy("invoiceNo", "desc"), limit(1));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        const latestInvoice = querySnapshot.docs[0].data();
        const latestNumber = parseInt(latestInvoice.invoiceNo);
        if (!isNaN(latestNumber) && latestNumber >= 1500) {
          setInvoiceNumber((latestNumber + 1).toString());
          setNextInvoiceNumber(latestNumber + 2);
        } else {
          setInvoiceNumber("1500");
          setNextInvoiceNumber(1501);
        }
      } else {
        setInvoiceNumber("1500");
        setNextInvoiceNumber(1501);
      }
    } catch (error) {
      console.error("Error fetching latest invoice number:", error);
      setInvoiceNumber("1500");
      setNextInvoiceNumber(1501);
    }
  };

  fetchLatestInvoiceNumber();
}, []);

// Update handleCreateInvoice to include selectedProduct and auto-increment
const handleCreateInvoice = async () => {
  if (!to || !date || !amount || deductAmount === undefined || !selectedProduct) {
    window.alert("Please fill in all required fields including product selection!");
    return;
  }

  try {
    const currentInvoiceNumber = invoiceNumber; // This is defined
    const totalAmount = parseFloat(amount) - parseFloat(deductAmount);

    const invoiceData = {
      to: String(to).trim(),
      patientPhoneNo: String(patientPhoneNo).trim(),
      paymentMethod: String(paymentMethod).trim(),
      date: String(date).trim(),
      description: String(description).trim(),
      amount: parseFloat(amount) || 0,
      deductAmount: parseFloat(deductAmount) || 0,
      totalAmount: totalAmount || 0,
      invoiceNo: currentInvoiceNumber, // Use currentInvoiceNumber here
      product: selectedProduct,
      createdAt: new Date(),
    };

    await addDoc(collection(db, "invoices"), invoiceData);

// --- Generate PDF ---
const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: [210, 148] });

// --- Font Setup ---
doc.setFont("helvetica", "normal");

// --- Header ---
const headerHeight = 25;
doc.setFillColor(255, 255, 255);
doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

// --- Logo (LEFT) ---
const logoHeight = 35;
const logoWidth = 70;
const logoY = (headerHeight - logoHeight) / 2;
const logoX = 10; // left aligned
doc.addImage("/invoice logo.png", "PNG", logoX, logoY, logoWidth, logoHeight);

// --- Address (RIGHT SIDE OF HEADER) ---
const pageWidth = doc.internal.pageSize.getWidth();
doc.setFont("helvetica", "bold");
doc.setFontSize(12);
doc.text("Southern rehab care", pageWidth - 10, 10, { align: "right" });

doc.setFont("helvetica", "normal");
doc.setFontSize(10);
doc.text("Hirimbura Rd, Karapitiya", pageWidth - 10, 15, { align: "right" });
doc.text("Tel: 0777439610 / 0714476402", pageWidth - 10, 20, { align: "right" });

// --- INVOICE Title (UNDERLINED) ---
doc.setFont("times", "bold");
doc.setFontSize(16);
doc.setTextColor(0, 0, 0);

const title = "INVOICE";
const titleY = 35;
doc.text(title, pageWidth / 2, titleY, { align: "center" });

// underline
const textWidth = doc.getTextWidth(title);
doc.line((pageWidth - textWidth) / 2, titleY + 2, (pageWidth + textWidth) / 2, titleY + 2);

// --- Invoice Details ---
doc.setFontSize(10);
const detailsY = 45;

// Patient Info
doc.text(`Patient: ${invoiceData.to}`, 10, detailsY);

// Invoice Number and Date
doc.text(`Invoice No: ${invoiceData.invoiceNo}`, pageWidth - 10, detailsY, { align: "right" });
doc.text(`Date: ${invoiceData.date}`, pageWidth - 10, detailsY + 7, { align: "right" });

// --- Table Section ---
let currentY = 60;

// Table Header
doc.setDrawColor(0);
doc.setFillColor(230, 230, 230); // Light gray header
doc.rect(10, currentY, pageWidth - 20, 8, "F");
doc.setFont("helvetica", "bold");
doc.setFontSize(10);
doc.setTextColor(0, 0, 0);
doc.text("DESCRIPTION", 12, currentY + 6);
doc.text("AMOUNT (Rs.)", pageWidth - 12, currentY + 6, { align: "right" });

currentY += 12;

// --- Product ---
if (invoiceData.product) {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("Product:", 12, currentY);
  doc.setFont("helvetica", "normal");
  doc.text(invoiceData.product, 35, currentY);
  currentY += 8;
}

// --- Description ---
if (invoiceData.description) {
  const descriptionLines = doc.splitTextToSize(invoiceData.description, pageWidth - 50);
  descriptionLines.forEach((line) => {
    doc.text(line, 12, currentY);
    currentY += 6;
  });
}

// Amount
doc.setFont("helvetica", "normal");
doc.setFontSize(10);
doc.text(`Rs. ${invoiceData.amount.toFixed(2)}`, pageWidth - 12, 72, { align: "right" });

// Deduction and Total
currentY = Math.max(currentY, 85);
doc.setFont("helvetica", "bold");

// Deduction
doc.text("Advance Payment", 12, currentY);
doc.text(`Rs. ${invoiceData.deductAmount.toFixed(2)}`, pageWidth - 12, currentY, { align: "right" });

// Total
currentY += 10;
doc.setFont("helvetica", "bold");
doc.setTextColor(0, 0, 0);
doc.text("BALANCE PAYABLE", 12, currentY);
doc.text(`Rs. ${invoiceData.totalAmount.toFixed(2)}`, pageWidth - 12, currentY, { align: "right" });

// Horizontal line
doc.setDrawColor(0);
doc.line(10, currentY + 5, pageWidth - 10, currentY + 5);

// --- Footer Info ---
const pageHeight = doc.internal.pageSize.getHeight();

// doc.setTextColor(0, 0, 0);
// doc.setFont("helvetica", "bold");
// doc.setFontSize(12);
// doc.text("Southern rehab care", pageWidth / 2, pageHeight - 30, { align: "center" });

// doc.setFont("helvetica", "normal");
// doc.setFontSize(10);
// doc.text("Hirimbura Rd, Karapitiya", pageWidth / 2, pageHeight - 24, { align: "center" });
// doc.text("Tel: 0777439610 / 0714476402", pageWidth / 2, pageHeight - 18, { align: "center" });

// --- Footer ---
doc.setFillColor(2, 135, 46); // Black footer
doc.rect(0, pageHeight - 10, pageWidth, 10, "F");
doc.setFont("helvetica", "bold");
doc.setFontSize(9);
doc.setTextColor(255, 255, 255);
doc.text(
  "Registered Office: 90/8E, Anagarika Darmapala mw, Karapitiya, Galle | (Reg no: 1/14/80/2018-12-18/13)",
  pageWidth / 2,
  pageHeight - 5,
  { align: "center" }
);

// Save PDF
doc.save(`Invoice_${currentInvoiceNumber}.pdf`);
     // Reset form
    setTo("");
    setPatientPhoneNo("");
    setPaymentMethod("cash");
    setDate("");
    setDescription("");
    setAmount("");
    setTotalAmount("");
    setDeductAmount(0);
    setSelectedProduct("");
    
    // Auto-increment invoice number for next invoice
    setInvoiceNumber(nextInvoiceNumber.toString());
    setNextInvoiceNumber(prev => prev + 1);

  } catch (error) {
    console.error("Error creating invoice: ", error);
    window.alert("Failed to create invoice. Please try again.");
  }
};











  
/////////////////////////////////// View invoices/////////////////////////////////////////////////////////////////
// Filters
const [statusFilter, setStatusFilter] = useState("");
const [monthFilter, setMonthFilter] = useState("");
const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");



const [invoices, setInvoices] = useState([]); // State to store invoices


const handleDownload = () => {
  if (invoices.length === 0) {
    alert("No invoices to download.");
    return;
  }

  // Define the column order you want
  const headers = [
    "invoiceNo",
    "patientPhoneNo",
    "to",
    "date",
    "brand",
    "right Lens",
    "left Lens",
    "add Power",
    "pd",
    "seg",
    "paymentMethod",
    "amount",
    "deductAmount",
    "totalAmount",
    "status",
    "frame",
    "lens"
  ];

  // Format invoices before exporting
  const formattedInvoices = invoices.map((inv) => {
    return {
      invoiceNo: inv.invoiceNo || "",
      patientPhoneNo: inv.patientPhoneNo || "",
      to: inv.to || "",
      date: inv.date || "",
      description: inv.description || "",
      brand: inv.brand || "",
      rightLens: inv.rightLens || "",
      leftLens: inv.leftLens || "",
      addPower: inv.addPower || "", 
      pd: inv.pd || "",
      seg: inv.seg || "",
      paymentMethod: inv.paymentMethod || "",
      amount: Number(inv.amount) || 0,
      deductAmount: Number(inv.deductAmount) || 0,
      totalAmount: Number(inv.totalAmount) || 0,

      status: inv.status || "",
      frame: inv.frame || "",
      lens: inv.lens || ""
    };
  });

  // Convert to worksheet (with headers in right order)
  const worksheet = XLSX.utils.json_to_sheet(formattedInvoices, { header: headers });

  // Set column headers explicitly
  XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: "A1" });

  // Create workbook and append
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

  // Trigger download
  XLSX.writeFile(workbook, "invoices.xlsx");
};







// Add these state variables at the top with your other states
const [filteredInvoices, setFilteredInvoices] = useState([]);

// Update the useEffect to include filtering
useEffect(() => {
  const fetchInvoices = async () => {
    try {
      const invoicesCollection = collection(db, "invoices");
      const invoiceSnapshot = await getDocs(invoicesCollection);
      const invoiceList = invoiceSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));
      
      setInvoices(invoiceList);
      setFilteredInvoices(invoiceList); // Initialize filtered invoices
    } catch (error) {
      console.error("Error fetching invoices: ", error);
    }
  };

  fetchInvoices();
}, []);


useEffect(() => {
  let data = invoices;

  // Search filter
  if (searchTerm.trim() !== "") {
    data = data.filter((invoice) =>
      invoice.to.toLowerCase().includes(searchTerm.toLowerCase()) ||
      invoice.invoiceNo.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }

  // Status filter
  if (statusFilter !== "") {
    data = data.filter((invoice) => (invoice.status || "") === statusFilter);
  }

  // Month filter (date must be YYYY-MM-DD format)
  if (monthFilter !== "") {
    data = data.filter((invoice) => {
      if (!invoice.date) return false;
      const month = invoice.date.split("-")[1];
      return month === monthFilter;
    });
  }



  // Date range filter (SAFE)
if (startDate !== "" || endDate !== "") {
  data = data.filter((inv) => {
    if (!inv.date) return false;

    // Convert invoice date to JS Date
    const invoiceDate = new Date(inv.date);
    const start = startDate ? new Date(startDate) : null;
    const end = endDate ? new Date(endDate) : null;

    if (start && invoiceDate < start) return false;
    if (end && invoiceDate > end) return false;

    return true;
  });
}

  setFilteredInvoices(data);
}, [searchTerm, statusFilter, monthFilter, startDate, endDate, invoices]);









// Add this function to delete an invoice
const handleDeleteInvoice = async (invoiceId) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this invoice?");
  if (!confirmDelete) return;

  try {
    await deleteDoc(doc(db, "invoices", invoiceId));
    
    // Update both invoices and filteredInvoices state
    setInvoices(invoices.filter(invoice => invoice.id !== invoiceId));
    setFilteredInvoices(filteredInvoices.filter(invoice => invoice.id !== invoiceId));
    
    alert("Invoice deleted successfully!");
  } catch (error) {
    console.error("Error deleting invoice: ", error);
    alert("Failed to delete invoice.");
  }
};







// Add this function to generate PDF for individual invoices
const generatePDF = (invoiceData) => {
  // Create PDF with A5 landscape size
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: [210, 148], // A5 landscape
  });

  // --- Professional Font Setup ---
  doc.setFont("helvetica", "normal");

  // --- Header ---
  const headerHeight = 25;
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, pageWidth, headerHeight, "F");

  // --- Logo (LEFT) ---
  const logoHeight = 35;
  const logoWidth = 70;
  const logoY = (headerHeight - logoHeight) / 2;
  const logoX = 10;

  doc.addImage("/invoice logo.png", "PNG", logoX, logoY, logoWidth, logoHeight);

  // --- Address (RIGHT SIDE OF HEADER) ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Southern rehab care", pageWidth - 10, 10, { align: "right" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("Hirimbura Rd, Karapitiya", pageWidth - 10, 15, { align: "right" });
  doc.text("Tel: 0777439610 / 0714476402", pageWidth - 10, 20, { align: "right" });

  // --- INVOICE Title ---
  doc.setFont("times", "bold");
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);

  const title = "INVOICE";
  const titleY = 35;

  doc.text(title, pageWidth / 2, titleY, { align: "center" });

  // underline
  const textWidth = doc.getTextWidth(title);

  doc.line(
    (pageWidth - textWidth) / 2,
    titleY + 2,
    (pageWidth + textWidth) / 2,
    titleY + 2
  );

  // --- Invoice Details ---
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  const detailsY = 45;

  doc.text(`Patient: ${invoiceData.to || ""}`, 10, detailsY);

  doc.text(
    `Invoice No: ${invoiceData.invoiceNo || ""}`,
    pageWidth - 10,
    detailsY,
    { align: "right" }
  );

  doc.text(
    `Date: ${invoiceData.date || ""}`,
    pageWidth - 10,
    detailsY + 7,
    { align: "right" }
  );

  // --- Table Section ---
  let currentY = 60;

  doc.setDrawColor(0);
  doc.setFillColor(230, 230, 230);
  doc.rect(10, currentY, pageWidth - 20, 8, "F");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);

  doc.text("DESCRIPTION", 12, currentY + 6);
  doc.text("AMOUNT (Rs.)", pageWidth - 12, currentY + 6, { align: "right" });

  currentY += 12;

  // --- Product ---
  if (invoiceData.product) {
    doc.setFont("helvetica", "bold");
    doc.text("Product:", 12, currentY);

    doc.setFont("helvetica", "normal");
    doc.text(invoiceData.product, 35, currentY);

    currentY += 8;
  }

  // --- Description ---
  if (invoiceData.description) {
    const descriptionLines = doc.splitTextToSize(
      invoiceData.description,
      pageWidth - 50
    );

    descriptionLines.forEach((line) => {
      doc.text(line, 12, currentY);
      currentY += 6;
    });
  }

  // Amount
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);

  doc.text(
    `Rs. ${(invoiceData.amount || 0).toFixed(2)}`,
    pageWidth - 12,
    72,
    { align: "right" }
  );

  // --- Deduction ---
  currentY = Math.max(currentY, 85);

  doc.text("Advance Payment", 12, currentY);

  doc.text(
    `Rs. ${(invoiceData.deductAmount || 0).toFixed(2)}`,
    pageWidth - 12,
    currentY,
    { align: "right" }
  );

  // --- Balance ---
  currentY += 10;

  doc.setFont("helvetica", "bold");

  doc.text("BALANCE PAYABLE", 12, currentY);

  doc.text(
    `Rs. ${(invoiceData.totalAmount || 0).toFixed(2)}`,
    pageWidth - 12,
    currentY,
    { align: "right" }
  );

  // --- Divider Line ---
  doc.setDrawColor(0);
  doc.line(10, currentY + 5, pageWidth - 10, currentY + 5);

  // --- Footer ---
  // doc.setFont("helvetica", "bold");
  // doc.setFontSize(12);

  // doc.text("Southern rehab care", pageWidth / 2, pageHeight - 30, {
  //   align: "center",
  // });

  // doc.setFont("helvetica", "normal");
  // doc.setFontSize(10);

  // doc.text("Hirimbura Rd, Karapitiya", pageWidth / 2, pageHeight - 24, {
  //   align: "center",
  // });

  // doc.text("Tel: 0777439610 / 0714476402", pageWidth / 2, pageHeight - 18, {
  //   align: "center",
  // });

  // --- Footer Bar ---
  doc.setFillColor(2, 135, 46);

  doc.rect(0, pageHeight - 10, pageWidth, 10, "F");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(255, 255, 255);

  doc.text(
    "Registered Office: 90/8E, Anagarika Darmapala mw, Karapitiya, Galle | (Reg no: 1/14/80/2018-12-18/13)",
    pageWidth / 2,
    pageHeight - 5,
    { align: "center" }
  );

  // Save PDF
  doc.save(`Invoice_${invoiceData.invoiceNo}.pdf`);
};













  // Handle Logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/"); // Redirect to login page after logout
    } catch (error) {
      console.error("Error during logout: ", error);
    }
  };
  

  // Example: Fetch user details (you might want to update this based on your logic)
  useEffect(() => {
    // Logic to fetch user details from Firestore or Firebase Auth
    const fetchUserDetails = async () => {
      const user = auth.currentUser;
      if (user) {
        // If the user is logged in, set userDetails (you can fetch more details from Firestore if needed)
        setUserDetails({
          name: user.displayName,
          email: user.email,
        });
      }
    };

    fetchUserDetails();
  }, [auth]);









//////////////////////////////////// patient followups ///////////////////////////////////////////////////




  const [notifications, setNotifications] = useState([]);
  const [todayCount, setTodayCount] = useState(0);
  const [error, setError] = useState(null);

  // Helper function to convert date to readable format
  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
  };

  // Helper function to check if date is today
  const isToday = (date) => {
    if (!date) return false;
    const d = new Date(date);
    const today = new Date();
    return (
      d.getDate() === today.getDate() &&
      d.getMonth() === today.getMonth() &&
      d.getFullYear() === today.getFullYear()
    );
  };

  // Helper function to get days difference
  const getDaysDifference = (date) => {
    if (!date) return 0;
    const d = new Date(date);
    const today = new Date();
    const diffTime = d - today;
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

useEffect(() => {
  setLoading(true);

  const patientsRef = collection(db, 'patients');
  const q = query(
    patientsRef,
    where("followUpDate", "!=", null),
    orderBy("followUpDate", "asc")
  );

  // Real-time listener
  const unsubscribe = onSnapshot(
    q,
    (querySnapshot) => {
      const fetchedNotifications = [];
      let todayNotifications = 0;

      querySnapshot.forEach((doc) => {
        const patientData = doc.data();
        const followUpDate = patientData.followUpDate;

        const dateValue = followUpDate.toDate ? followUpDate.toDate() : new Date(followUpDate);

        const notification = {
          ...patientData,
          id: doc.id,
          patientName: patientData.name || 'Unknown Patient',
          followUpDate: dateValue,
          formattedDate: formatDate(dateValue),
          isToday: isToday(dateValue),
          daysDifference: getDaysDifference(dateValue),
          status: patientData.status || 'pending',
        };

        if (notification.daysDifference >= 0) {
          fetchedNotifications.push(notification);
          if (notification.isToday) todayNotifications++;
        }
      });

      setNotifications(fetchedNotifications);
      setTodayCount(todayNotifications);
      setLoading(false);
    },
    (err) => {
      console.error("Error fetching notifications:", err);
      setError("Failed to load notifications. Please try again later.");
      setLoading(false);
    }
  );

  // Cleanup listener on unmount
  return () => unsubscribe();
}, []);

  const getPriorityColor = (date) => {
    if (!date) return '#52c41a';
    const today = new Date();
    const diffInDays = getDaysDifference(date);
    
    if (isToday(date)) return '#ff4d4f'; // Red for today
    if (diffInDays <= 3) return '#faad14'; // Yellow for upcoming 3 days
    return '#52c41a'; // Green for future dates
  };


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  

const handleStatusChange = async (invoiceId, newStatus) => {
  try {
    const invoiceRef = doc(db, "invoices", invoiceId);
    await updateDoc(invoiceRef, { status: newStatus });
    // Update local state too
    setInvoices((prev) =>
      prev.map((inv) =>
        inv.id === invoiceId ? { ...inv, status: newStatus } : inv
      )
    );
  } catch (err) {
    console.error("Error updating status:", err);
  }
};



/////////////////////////////////////////////////////  sales report  ///////////////////////////////////////////////////////////
  const [filterMode, setFilterMode] = useState("daily"); // daily | monthly | yearly
  const [selectedDate, setSelectedDate] = useState(dayjs());

  const [totalSale, setTotalSale] = useState(0);
  const [totalPaid, setTotalPaid] = useState(0);
  const [totalPayable, setTotalPayable] = useState(0);

  // ✅ Fetch invoices
  const fetchInvoices = useCallback(async () => {
    try {
      const snapshot = await getDocs(collection(db, "invoices"));
      const list = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setInvoices(list);
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  }, []);

  useEffect(() => {
    fetchInvoices();
  }, [fetchInvoices]);

  // ✅ Filter logic
  const filteredInvoicesInSale = invoices.filter((inv) => {
    const invDate = dayjs(inv.date);
    if (filterMode === "daily") {
      return invDate.isSame(selectedDate, "day");
    } else if (filterMode === "monthly") {
      return (
        invDate.month() === selectedDate.month() &&
        invDate.year() === selectedDate.year()
      );
    } else if (filterMode === "yearly") {
      return invDate.year() === selectedDate.year();
    }
    return true;
  });

  // ✅ Calculate summaries
  useEffect(() => {
    const totalS = filteredInvoicesInSale.reduce((acc, curr) => acc + (curr.amount || 0), 0);
    const totalP = filteredInvoicesInSale.reduce((acc, curr) => acc + (curr.deductAmount || 0), 0);
    const totalBal = filteredInvoicesInSale.reduce(
      (acc, curr) => acc + ((curr.amount || 0) - (curr.deductAmount || 0)),
      0
    );

    setTotalSale(totalS);
    setTotalPaid(totalP);
    setTotalPayable(totalBal);
  }, [filteredInvoicesInSale]);


// --- Inside your Body component ---
const downloadExcel = () => {
  // Use filteredInvoicesInSale (filtered) or all invoices
  const dataToExport = filteredInvoicesInSale.length > 0 ? filteredInvoicesInSale : invoices;

  if (!dataToExport || dataToExport.length === 0) {
    alert("No invoices to export!");
    return;
  }

  // Map data to clean Excel structure
  const exportData = dataToExport.map((inv) => {
    const payable = (inv.amount || 0) - (inv.deductAmount || 0);
    return {
      Date: inv.date,
      "Invoice No": inv.invoiceNo,
      Customer: inv.to,
      Phone: inv.patientPhoneNo,
      "Payment Method": inv.paymentMethod,
      Device: inv.product,
      "Full Price": inv.amount,
      Advanced: inv.deductAmount,
      "Payable Balance": payable,
    };
  });

  const worksheet = XLSX.utils.json_to_sheet(exportData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sales Report");

  // Generate Excel file
  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
  saveAs(blob, `Sales_Report_${dayjs().format("YYYYMMDD_HHmmss")}.xlsx`);
};

















const downloadSalesReportPDF = () => {
  const doc = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();

  let currentY = 20;

  // --- Header ---
  doc.setFont("helvetica", "bold");
  doc.setFontSize(16);
  doc.text("Southern rehab care", pageWidth / 2, currentY, { align: "center" });
  currentY += 6;

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("Hirimbura Rd, Karapitiya", pageWidth / 2, currentY, { align: "center" });
  currentY += 5;
  doc.text("Tel: 0777439610 / 0714476402 ", pageWidth / 2, currentY, { align: "center" });
  currentY += 5;

  doc.setFont("helvetica", "bold");
  doc.text("Sales Report", pageWidth / 2, currentY, { align: "center" });
  currentY += 6;

  // --- Report Period ---
  let periodText = "";
  if (filterMode === "daily") periodText = `Date: ${selectedDate.format("YYYY-MM-DD")}`;
  else if (filterMode === "monthly") periodText = `Month: ${selectedDate.format("MMMM YYYY")}`;
  else if (filterMode === "yearly") periodText = `Year: ${selectedDate.format("YYYY")}`;

  doc.text(periodText, pageWidth / 2, currentY, { align: "center" });
  currentY += 8;

  // --- Table Columns & Rows ---
  const tableColumn = [
    "Date", "Invoice No", "Customer", "Phone", "Payment Method", "Device Type", 
     "Full Price", "Advanced", "Payable Balance"
  ];

  const tableRows = filteredInvoicesInSale.map(inv => {
    const payable = (inv.amount || 0) - (inv.deductAmount || 0);
    return [
      inv.date,
      inv.invoiceNo,
      inv.to,
      inv.patientPhoneNo,
      inv.paymentMethod,
      inv.product,
      `Rs. ${inv.amount}`,
      `Rs. ${inv.deductAmount}`,
      `Rs. ${payable}`
    ];
  });

  // --- Use autoTable plugin correctly ---
  autoTable(doc, {
    startY: currentY,
    head: [tableColumn],
    body: tableRows,
    headStyles: { fillColor: [173, 216, 230], textColor: 0, fontStyle: "bold" },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    styles: { fontSize: 8 },
    theme: "grid",
    margin: { left: 10, right: 10 },
  });

  // --- Summary ---
  const finalY = doc.lastAutoTable.finalY + 6;
  doc.setFont("helvetica", "bold");
  doc.text(`Total Sale: Rs. ${totalSale.toLocaleString()}`, 10, finalY);
  doc.text(`Total Paid: Rs. ${totalPaid.toLocaleString()}`, 60, finalY);
  doc.text(`Total Balance: Rs. ${totalPayable.toLocaleString()}`, 120, finalY);

  // --- Footer ---
  const footerY = doc.internal.pageSize.getHeight() - 10;
 
doc.setFillColor(2, 135, 46);

  doc.rect(0, footerY, pageWidth, 10, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(255, 255, 255);
  doc.text(
   "Registered Office: 90/8E, Anagarika Darmapala mw, Karapitiya, Galle | (Reg no: 1/14/80/2018-12-18/13)",
    pageWidth / 2,
    footerY + 5,
    { align: "center" }
  );

  // Save PDF
  doc.save(`Sales_Report_${filterMode}_${selectedDate.format("YYYYMMDD")}.pdf`);
};







//////////////////////////////////////////////////////// create settle invoice //////////////////////////////////////////////////////////////////////


const searchInvoice = async () => {
  try {
    const q = query(
      collection(db, "invoices"),
      where("invoiceNo", "==", searchInvoiceNo)
    );

    const snap = await getDocs(q);

    if (snap.empty) {
      window.alert("Invoice not found!");
      setFoundInvoice(null);
      return;
    }

    const data = snap.docs[0].data();
    setFoundInvoice({ id: snap.docs[0].id, ...data });

    // Remaining balance
    const balance = parseFloat(data.totalAmount);
    setBalanceAfterSettle(balance);

  } catch (e) {
    console.error(e);
  }
};



const handleSettlePayment = async () => {
  if (!foundInvoice) {
    alert("Search invoice first!");
    return;
  }

  if (!settleDate) {
    alert("Please select settlement date.");
    return;
  }

  const balance = parseFloat(foundInvoice.totalAmount);
  const paidNow = parseFloat(settleAmount);

  if (paidNow <= 0 || paidNow > balance) {
    alert("Invalid settle amount.");
    return;
  }

  const newBalance = balance - paidNow;

  try {
    // 1️⃣ Create settlement record
    await addDoc(collection(db, "settlements"), {
      invoiceNo: foundInvoice.invoiceNo,
      paidAmount: paidNow,
      previousBalance: balance,
      newBalance: newBalance,
      date: new Date(settleDate), // ✅ USER DATE
    });

    // 2️⃣ Update invoice balance
    await updateDoc(doc(db, "invoices", foundInvoice.id), {
      totalAmount: newBalance,
    });

    // 3️⃣ Generate PDF
    createSettlementPDF(foundInvoice, paidNow, newBalance, settleDate);

    alert("Settlement completed!");

    setFoundInvoice(null);
    setSearchInvoiceNo("");
    setSettleAmount("");
    setSettleDate("");
  } catch (e) {
    console.error(e);
    alert("Failed to settle!");
  }
};




const createSettlementPDF = (invoice, paidNow, newBalance, settleDate) => { 
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "mm",
    format: "a5",
  });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  /* -------------------- HEADER -------------------- */
  const headerHeight = 25;
  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, pageWidth, headerHeight, "F");

  // LOGO (LEFT)
  const logoWidth = 70;
  const logoHeight = 30;
  const logoX = 10; // left aligned
  const logoY = 3;
  doc.addImage("/invoice logo.png", "PNG", logoX, logoY, logoWidth, logoHeight);

  // HEADER ADDRESS (RIGHT)
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Southern Rehab Care", pageWidth - 10, 10, { align: "right" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("Hirimbura Rd, Karapitiya", pageWidth - 10, 15, { align: "right" });
  doc.text("Tel: 0777439610 / 0714476402", pageWidth - 10, 20, { align: "right" });

  /* -------------------- TITLE -------------------- */
  doc.setFont("times", "bold");
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);

  const title = "SETTLEMENT BILL";
  const titleY = headerHeight + 10;
  doc.text(title, pageWidth / 2, titleY, { align: "center" });

  // underline title
  const textWidth = doc.getTextWidth(title);
  doc.line((pageWidth - textWidth) / 2, titleY + 2, (pageWidth + textWidth) / 2, titleY + 2);

  /* -------------------- BASIC DETAILS -------------------- */
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);

  let y = headerHeight + 22;

  doc.text(`Invoice No: ${invoice.invoiceNo}`, 10, y);
  y += 7;

  doc.text(`Patient: ${invoice.to}`, 10, y);
  y += 7;

  doc.text(
    `Date: ${new Date(settleDate).toLocaleDateString()}`,
    10,
    y
  );
  y += 12;

  /* -------------------- PAYMENT DETAILS -------------------- */
  const rightX = pageWidth - 70;

  doc.setFont("helvetica", "bold");
  doc.text("Total Amount of Device:", 10, y);
  doc.text(`Rs. ${invoice.amount.toFixed(2)}`, rightX, y);

  y += 10;

  doc.setFont("helvetica", "bold");
  doc.text("Previous Balance:", 10, y);
  doc.text(`Rs. ${invoice.totalAmount.toFixed(2)}`, rightX, y);

  y += 10;

  doc.text("Amount Paid Now:", 10, y);
  doc.text(`Rs. ${paidNow.toFixed(2)}`, rightX, y);

  y += 10;

  doc.text("New Remaining Balance:", 10, y);
  doc.text(`Rs. ${newBalance.toFixed(2)}`, rightX, y);


  /* -------------------- FOOTER DETAILS -------------------- */
  // doc.setFont("helvetica", "bold");
  // doc.setFontSize(12);
  // doc.text("Southern Rehab Care", pageWidth / 2, pageHeight - 30, {
  //   align: "center",
  // });

  // doc.setFont("helvetica", "normal");
  // doc.setFontSize(10);
  // doc.text("Hirimbura Rd, Karapitiya", pageWidth / 2, pageHeight - 24, { align: "center" });
  // doc.text("Tel: 0777439610 / 0714476402", pageWidth / 2, pageHeight - 18, { align: "center" });


  /* -------------------- BLACK FOOTER STRIP -------------------- */
  doc.setFillColor(2, 135, 46); // Black footer
  doc.rect(0, pageHeight - 10, pageWidth, 10, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(255, 255, 255);
  doc.text(
    "Registered Office: 90/8E, Anagarika Darmapala mw, Karapitiya, Galle | (Reg no: 1/14/80/2018-12-18/13)",
    pageWidth / 2,
    pageHeight - 4,
    { align: "center" }
  );

  /* -------------------- SAVE PDF -------------------- */
  doc.save(`Settlement_${invoice.invoiceNo}.pdf`);
};








/////////////////////// view all settle invoices ///////////////////////////////////////////////////////////

const [loadingInvoices, setLoadingInvoices] = useState(true);


// Fetch invoices and settlements
useEffect(() => {
  const fetchInvoices = async () => {
    setLoadingInvoices(true);
    try {
      const invoiceSnapshot = await getDocs(collection(db, "invoices"));
      const settleSnapshot = await getDocs(collection(db, "settlements"));

      const invoiceData = invoiceSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const settleData = settleSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      const merged = invoiceData.map(inv => ({
        ...inv,
        settlements: settleData.filter(s => String(s.invoiceNo).trim() === String(inv.invoiceNo).trim()),
      }));

      setInvoices(merged);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingInvoices(false);
    }
  };

  fetchInvoices();
}, []);






  const getSafeDate = (date) =>
    date?.toDate ? date.toDate() : date ? new Date(date) : null;





const handleDeleteSettleInvoice = async (invoice) => {
  const confirmDelete = window.confirm(
    `Delete invoice ${invoice.invoiceNo} and all its settlements?`
  );

  if (!confirmDelete) return;

  try {
    const batch = writeBatch(db);

    // Delete invoice
    batch.delete(doc(db, "invoices", invoice.id));

    // Delete related settlements
    invoice.settlements?.forEach((s) => {
      batch.delete(doc(db, "settlements", s.id));
    });

    await batch.commit();

    // Remove from UI
    setInvoices((prev) =>
      prev.filter((inv) => inv.id !== invoice.id)
    );
  } catch (error) {
    console.error("Delete failed:", error);
    alert("Failed to delete invoice");
  }
};




// --- Download PDF --- 
const downloadSettlementInvoice = (invoice) => {
  const doc = new jsPDF({ orientation: "potrait", unit: "mm", format: [296, 210] });

  const headerHeight = 25;
  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

  const logoHeight = 35;
  const logoWidth = 70;
  const logoY = (headerHeight - logoHeight) / 2;
  const logoX = 10; // left aligned
  doc.addImage("/invoice logo.png", "PNG", logoX, logoY, logoWidth, logoHeight);

  // HEADER ADDRESS (RIGHT)
  const pageWidth = doc.internal.pageSize.getWidth();
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Southern Rehab Care", pageWidth - 10, 10, { align: "right" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("Hirimbura Rd, Karapitiya", pageWidth - 10, 15, { align: "right" });
  doc.text("Tel: 0777439610 / 0714476402", pageWidth - 10, 20, { align: "right" });

  // --- TITLE ---
  doc.setFont("times", "bold");
  doc.setFontSize(16);
  doc.setTextColor(0, 0, 0);
  const title = "INVOICE (Settlement)";
  const titleY = 35;
  doc.text(title, pageWidth / 2, titleY, { align: "center" });

  // underline title
  const textWidth = doc.getTextWidth(title);
  doc.line((pageWidth - textWidth) / 2, titleY + 2, (pageWidth + textWidth) / 2, titleY + 2);

  // --- Invoice Details ---
  const detailsY = 45;
  doc.setFontSize(10);
  doc.text(`Patient: ${invoice.to}`, 10, detailsY);
  doc.text(`Invoice No: ${invoice.invoiceNo}`, pageWidth - 10, detailsY, { align: "right" });
  doc.text(`Date: ${invoice.date}`, pageWidth - 10, detailsY + 7, { align: "right" });

  // --- Table Section ---
  let currentY = 60;
  doc.setDrawColor(0);
  doc.setFillColor(173, 216, 230);
  doc.rect(10, currentY, pageWidth - 20, 8, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("DESCRIPTION", 12, currentY + 6);
  doc.text("AMOUNT (Rs.) / Paid / Balance", pageWidth - 12, currentY + 6, { align: "right" });
  currentY += 12;

  if (invoice.product) {
    doc.setFont("helvetica", "bold");
    doc.text("Device Type:", 12, currentY);
    doc.setFont("helvetica", "normal");
    doc.text(invoice.product, 35, currentY);
    currentY += 8;
  }

  doc.setFont("helvetica", "bold");
  doc.text("Total Amount of Device:", 12, currentY);
  doc.setFont("helvetica", "normal");
  doc.text(`Rs. ${invoice.amount.toFixed(2)}`, pageWidth - 12, currentY, { align: "right" });
  currentY += 10;

  doc.setFont("helvetica", "bold");
  doc.text("Advance Paid:", 12, currentY);
  doc.setFont("helvetica", "normal");
  doc.text(`Rs. ${invoice.deductAmount.toFixed(2)}`, pageWidth - 12, currentY, { align: "right" });
  currentY += 10;

  doc.setFont("helvetica", "bold");
  doc.text("Total Balance payable:", 12, currentY);
  doc.setFont("helvetica", "normal");
  doc.text(`Rs. ${invoice.totalAmount.toFixed(2)}`, pageWidth - 12, currentY, { align: "right" });
  currentY += 10;

  if (invoice.settlements && invoice.settlements.length > 0) {
    doc.setFont("helvetica", "bold");
    doc.text("SETTLEMENTS:", 12, currentY);
    currentY += 8;

    invoice.settlements.forEach((s, index) => {
      doc.text(
        `${index + 1}. Date: ${getSafeDate(s.date)?.toLocaleDateString()} | Paid: Rs. ${s.paidAmount.toFixed(
          2
        )} | Balance Amount: Rs. ${s.newBalance.toFixed(2)}`,
        12,
        currentY
      );
      currentY += 6;
    });
  } else {
    doc.setFont("helvetica", "normal");
    doc.text("No settlements recorded.", 12, currentY);
    currentY += 6;
  }

  const pageHeight = doc.internal.pageSize.getHeight();
  currentY = Math.max(currentY + 10, 120);

  // --- Footer ---
  // doc.setFont("helvetica", "bold");
  // doc.setFontSize(12);
  // doc.text("Southern rehab care", pageWidth / 2, pageHeight - 30, { align: "center" });

  // doc.setFont("helvetica", "normal");
  // doc.setFontSize(10);
  // doc.text("Hirimbura Rd, Karapitiya", pageWidth / 2, pageHeight - 24, { align: "center" });
  // doc.text("Tel: 0777439610 / 0714476402", pageWidth / 2, pageHeight - 18, { align: "center" });

  doc.setFillColor(2, 135, 46);
  doc.rect(0, pageHeight - 10, pageWidth, 10, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.setTextColor(255, 255, 255);
  doc.text(
    "Registered Office: 90/8E, Anagarika Darmapala mw, Karapitiya, Galle | (Reg no: 1/14/80/2018-12-18/13)",
    pageWidth / 2,
    pageHeight - 5,
    { align: "center" }
  );

  doc.save(`Settlement_Invoice_${invoice.invoiceNo}.pdf`);
};





// --- Filter States ---
const [filterYear, setFilterYear] = useState("");
const [filterMonth, setFilterMonth] = useState("");
const [filterDate, setFilterDate] = useState("");
const [filterInvoiceNo, setFilterInvoiceNo] = useState("");
const [filterPatient, setFilterPatient] = useState("");

// --- Filtered invoices ---
const filteredSettleInvoices = useMemo(() => {
  return invoices.filter((inv) => {
    if (!inv.settlements || inv.settlements.length === 0) return false;

    let matches = true;

    // Use first settlement date for filtering
    const settlementDate = getSafeDate(inv.settlements[0]?.date);

    if (filterYear && settlementDate) {
      matches &&= settlementDate.getFullYear().toString() === filterYear;
    }

    if (filterMonth && settlementDate) {
      matches &&=
        String(settlementDate.getMonth() + 1).padStart(2, "0") === filterMonth;
    }

    if (filterDate && settlementDate) {
      matches &&=
        String(settlementDate.getDate()).padStart(2, "0") === filterDate;
    }

    if (filterInvoiceNo) {
      matches &&= String(inv.invoiceNo)
        .toLowerCase()
        .includes(filterInvoiceNo.toLowerCase());
    }

    if (filterPatient) {
      const patientData = `${inv.to || ""}${inv.patientPhoneNo || ""}`.toLowerCase();
      matches &&= patientData.includes(filterPatient.toLowerCase());
    }

    return matches;
  });
}, [invoices, filterYear, filterMonth, filterDate, filterInvoiceNo, filterPatient]);




///////////////////////////////////////////create quotation ////////////////////////////////////////////////////////



// Add these new state variables for Quotation
const [quotationNumber, setQuotationNumber] = useState("Q-1500");
const [nextQuotationNumber, setNextQuotationNumber] = useState(1501);
const [quotationTo, setQuotationTo] = useState("");
const [quotationPatientPhoneNo, setQuotationPatientPhoneNo] = useState("");
const [quotationDate, setQuotationDate] = useState("");
const [quotationDescription, setQuotationDescription] = useState("");
const [quotationAmount, setQuotationAmount] = useState("");
const [quotationSelectedProduct, setQuotationSelectedProduct] = useState("");

// Fetch the latest quotation number when component mounts
useEffect(() => {
  const fetchLatestQuotationNumber = async () => {
    try {
      const quotationsRef = collection(db, "quotations");
      const q = query(quotationsRef, orderBy("quotationNo", "desc"), limit(1));
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        const latestQuotation = querySnapshot.docs[0].data();
        const latestNumber = parseInt(latestQuotation.quotationNo.replace('Q-', ''));
        if (!isNaN(latestNumber) && latestNumber >= 1500) {
          setQuotationNumber(`Q-${latestNumber + 1}`);
          setNextQuotationNumber(latestNumber + 2);
        } else {
          setQuotationNumber("Q-1500");
          setNextQuotationNumber(1501);
        }
      } else {
        setQuotationNumber("Q-1500");
        setNextQuotationNumber(1501);
      }
    } catch (error) {
      console.error("Error fetching latest quotation number:", error);
      setQuotationNumber("Q-1500");
      setNextQuotationNumber(1501);
    }
  };

  fetchLatestQuotationNumber();
}, []);

// Handle Create Quotation
const handleCreateQuotation = async () => {
  if (!quotationTo || !quotationDate || !quotationAmount || !quotationSelectedProduct) {
    window.alert("Please fill in all required fields including product selection!");
    return;
  }

  try {
    const currentQuotationNumber = quotationNumber;

    const quotationData = {
      to: String(quotationTo).trim(),
      patientPhoneNo: String(quotationPatientPhoneNo).trim(),
      date: String(quotationDate).trim(),
      description: String(quotationDescription).trim(),
      amount: parseFloat(quotationAmount) || 0,
      quotationNo: currentQuotationNumber,
      product: quotationSelectedProduct,
      createdAt: new Date(),
      status: "active",
    };

    await addDoc(collection(db, "quotations"), quotationData);

// --- Generate Quotation PDF in A4 Portrait --- 
const doc = new jsPDF({ 
  orientation: "portrait", 
  unit: "mm", 
  format: "a4" // A4 Portrait (210mm x 297mm)
});

// --- Font Setup ---
doc.setFont("helvetica", "normal");

// --- Header ---
const headerHeight = 35;
doc.setFillColor(255, 255, 255);
doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

// Logo - left aligned
const logoHeight = 35;
const logoWidth = 70;
const pageWidth = doc.internal.pageSize.getWidth();
const logoY = (headerHeight - logoHeight) / 2;
const logoX = 10; // left aligned
doc.addImage("/invoice logo.png", "PNG", logoX, logoY, logoWidth, logoHeight);

// Header Address - right aligned
doc.setFont("helvetica", "bold");
doc.setFontSize(12);
doc.text("Southern rehab care", pageWidth - 10, 10, { align: "right" });

doc.setFont("helvetica", "normal");
doc.setFontSize(10);
doc.text("Hirimbura Rd, Karapitiya", pageWidth - 10, 15, { align: "right" });
doc.text("Tel: 0777439610 / 0714476402", pageWidth - 10, 20, { align: "right" });

// --- QUOTATION Title ---
doc.setFont("times", "bold");
doc.setFontSize(20);
doc.setTextColor(0, 0, 0);
const title = "QUOTATION";
const yPosition = 45;
doc.text(title, pageWidth / 2, yPosition, { align: "center" });

// Underline
const textWidth = doc.getTextWidth(title);
doc.line(
  (pageWidth - textWidth) / 2,
  yPosition + 2,
  (pageWidth + textWidth) / 2,
  yPosition + 2
);

// --- Quotation Details ---
doc.setFontSize(11);

// Quotation Number and Date (side by side)
doc.text(`Quotation No: ${quotationData.quotationNo}`, 20, 55);
doc.text(`Date: ${quotationData.date}`, pageWidth - 20, 55, { align: "right" });

// Patient Info
doc.setFont("helvetica", "bold");
doc.text("Patient Details:", 20, 65);
doc.setFont("helvetica", "normal");
doc.text(`Name: ${quotationData.to}`, 25, 72);
doc.text(`Phone: ${quotationData.patientPhoneNo || 'N/A'}`, 25, 79);

// --- Table Section ---
let currentY = 90;

// Table Header
doc.setDrawColor(0);
doc.setFillColor(230, 230, 230);
doc.rect(20, currentY, pageWidth - 40, 10, "F");
doc.setFont("helvetica", "bold");
doc.setFontSize(11);
doc.setTextColor(0, 0, 0);
doc.text("DESCRIPTION", 25, currentY + 7);
doc.text("AMOUNT (Rs.)", pageWidth - 25, currentY + 7, { align: "right" });

currentY += 15;

// --- Product ---
if (quotationData.product) {
  doc.setFont("helvetica", "bold");
  doc.setFontSize(10);
  doc.text("Product:", 20, currentY);
  doc.setFont("helvetica", "normal");

  // Handle long product names with wrapping
  const productLines = doc.splitTextToSize(quotationData.product, 120);
  doc.text(productLines, 45, currentY);
  currentY += (productLines.length * 6);
}

// --- Description ---
if (quotationData.description) {
  doc.setFont("helvetica", "bold");
  doc.text("Description:", 20, currentY);
  doc.setFont("helvetica", "normal");
  const descriptionLines = doc.splitTextToSize(quotationData.description, 150);
  doc.text(descriptionLines, 45, currentY);
  currentY += (descriptionLines.length * 6) + 5;
} else {
  currentY += 5;
}

// Amount row
doc.setFont("helvetica", "normal");
doc.setFontSize(11);
doc.text("Total Amount:", 25, currentY);
doc.setFont("helvetica", "bold");
doc.text(`Rs. ${quotationData.amount.toFixed(2)}`, pageWidth - 25, currentY, { align: "right" });

currentY += 15;

// Horizontal line
doc.setDrawColor(200, 200, 200);
doc.line(20, currentY, pageWidth - 20, currentY);

currentY += 10;

// --- Terms and Conditions ---
doc.setFont("helvetica", "bold");
doc.setFontSize(11);
doc.text("Terms & Conditions:", 20, currentY);

currentY += 7;
doc.setFont("helvetica", "normal");
doc.setFontSize(10);

// Term 1
doc.text("• Follow up with extended services.", 25, currentY);
currentY += 6;

// Term 2
doc.text("• Quotation validity only for 60 days.", 25, currentY);
currentY += 6;

// Term 3
doc.text("• Please note that prices are subject to change according to fluctuating foreign currency rates.", 25, currentY);

currentY += 15;

// --- Footer Bar ---
const pageHeight = doc.internal.pageSize.getHeight();
doc.setFillColor(2, 135, 46);
doc.rect(0, pageHeight - 15, pageWidth, 15, "F");
doc.setFont("helvetica", "bold");
doc.setFontSize(8);
doc.setTextColor(255, 255, 255);
doc.text(
  "Registered Office: 90/8E, Anagarika Darmapala mw, Karapitiya, Galle | (Reg no: 1/14/80/2018-12-18/13)",
  pageWidth / 2,
  pageHeight - 7,
  { align: "center" }
);

// Save PDF
doc.save(`Quotation_${currentQuotationNumber}.pdf`);

    // Reset form
    setQuotationTo("");
    setQuotationPatientPhoneNo("");
    setQuotationDate("");
    setQuotationDescription("");
    setQuotationAmount("");
    setQuotationSelectedProduct("");
    
    // Auto-increment quotation number for next quotation
    setQuotationNumber(`Q-${nextQuotationNumber}`);
    setNextQuotationNumber(prev => prev + 1);

  } catch (error) {
    console.error("Error creating quotation: ", error);
    window.alert("Failed to create quotation. Please try again.");
  }
};





/////////////////////////// view all quotations ///////////////////////////////


// Add these state variables for quotations
const [quotations, setQuotations] = useState([]);
const [filteredQuotations, setFilteredQuotations] = useState([]);


// Fetch quotations from Firebase
useEffect(() => {
  const fetchQuotations = async () => {
    setLoading(true);
    try {
      const quotationsRef = collection(db, "quotations");
      const q = query(quotationsRef, orderBy("createdAt", "desc"));
      const querySnapshot = await getDocs(q);
      
      const quotationsList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      setQuotations(quotationsList);
      setFilteredQuotations(quotationsList);
    } catch (error) {
      console.error("Error fetching quotations: ", error);
    } finally {
      setLoading(false);
    }
  };

  fetchQuotations();
}, []);

// Filter quotations based on search, month, and date range
useEffect(() => {
  let filtered = [...quotations];

  // Search filter
  if (searchTerm) {
    filtered = filtered.filter(quotation => 
      quotation.to?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      quotation.quotationNo?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      quotation.product?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      quotation.patientPhoneNo?.includes(searchTerm)
    );
  }

  // Month filter
  if (monthFilter) {
    filtered = filtered.filter(quotation => {
      if (!quotation.date) return false;
      const [year, month] = quotation.date.split('-');
      return month === monthFilter;
    });
  }

  // Date range filter
  if (startDate && endDate) {
    filtered = filtered.filter(quotation => {
      if (!quotation.date) return false;
      return quotation.date >= startDate && quotation.date <= endDate;
    });
  } else if (startDate) {
    filtered = filtered.filter(quotation => quotation.date >= startDate);
  } else if (endDate) {
    filtered = filtered.filter(quotation => quotation.date <= endDate);
  }

  setFilteredQuotations(filtered);
}, [searchTerm, monthFilter, startDate, endDate, quotations]);

// Handle delete quotation
const handleDeleteQuotation = async (id) => {
  if (window.confirm("Are you sure you want to delete this quotation?")) {
    try {
      await deleteDoc(doc(db, "quotations", id));
      setQuotations(quotations.filter(q => q.id !== id));
      setFilteredQuotations(filteredQuotations.filter(q => q.id !== id));
      window.alert("Quotation deleted successfully!");
    } catch (error) {
      console.error("Error deleting quotation: ", error);
      window.alert("Failed to delete quotation. Please try again.");
    }
  }
};

// Generate PDF for quotation 
const generateQuotationPDF = (quotationData) => {
  // Use the same PDF generation function from handleCreateQuotation
  const doc = new jsPDF({ 
    orientation: "portrait", 
    unit: "mm", 
    format: "a4"
  });

  doc.setFont("helvetica", "normal");

  // Header
  const headerHeight = 35;
  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, doc.internal.pageSize.getWidth(), headerHeight, "F");

  // Logo - left aligned
  const logoHeight = 35;
  const logoWidth = 70;
  const pageWidth = doc.internal.pageSize.getWidth();
  const logoY = (headerHeight - logoHeight) / 2;
  const logoX = 10; // left aligned
  doc.addImage("/invoice logo.png", "PNG", logoX, logoY, logoWidth, logoHeight);

  // Header address - right aligned
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);
  doc.text("Southern rehab care", pageWidth - 10, 10, { align: "right" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("Hirimbura Rd, Karapitiya", pageWidth - 10, 15, { align: "right" });
  doc.text("Tel: 0777439610 / 0714476402", pageWidth - 10, 20, { align: "right" });

  // Title
  // --- QUOTATION Title ---
  doc.setFont("times", "bold");
  doc.setFontSize(20);
  doc.setTextColor(0, 0, 0);

  const title = "QUOTATION";
  const yPosition = 45;

  doc.text(title, pageWidth / 2, yPosition, { align: "center" });

  // Underline
  const textWidth = doc.getTextWidth(title);
  doc.line(
    (pageWidth - textWidth) / 2,
    yPosition + 2,
    (pageWidth + textWidth) / 2,
    yPosition + 2
  );

  // Details
  doc.setFontSize(11);
  doc.text(`Quotation No: ${quotationData.quotationNo}`, 20, 55);
  doc.text(`Date: ${quotationData.date}`, pageWidth - 20, 55, { align: "right" });

  // Patient Info
  doc.setFont("helvetica", "bold");
  doc.text("Patient Details:", 20, 65);
  doc.setFont("helvetica", "normal");
  doc.text(`Name: ${quotationData.to}`, 25, 72);
  doc.text(`Phone: ${quotationData.patientPhoneNo || 'N/A'}`, 25, 79);

  // Table
  let currentY = 90;
  doc.setDrawColor(0);
  doc.setFillColor(230, 230, 230);
  doc.rect(20, currentY, pageWidth - 40, 10, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("DESCRIPTION", 25, currentY + 7);
  doc.text("AMOUNT (Rs.)", pageWidth - 25, currentY + 7, { align: "right" });

  currentY += 15;

  // Product
  if (quotationData.product) {
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("Product:", 20, currentY);
    doc.setFont("helvetica", "normal");
    const productLines = doc.splitTextToSize(quotationData.product, 120);
    doc.text(productLines, 45, currentY);
    currentY += (productLines.length * 6);
  }

  // Description
  if (quotationData.description) {
    doc.setFont("helvetica", "bold");
    doc.text("Description:", 20, currentY);
    doc.setFont("helvetica", "normal");
    const descriptionLines = doc.splitTextToSize(quotationData.description, 150);
    doc.text(descriptionLines, 45, currentY);
    currentY += (descriptionLines.length * 6) + 5;
  } else {
    currentY += 5;
  }

  // Amount
  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.text("Total Amount:", 25, currentY);
  doc.setFont("helvetica", "bold");
  doc.text(`Rs. ${quotationData.amount?.toFixed(2) || '0.00'}`, pageWidth - 25, currentY, { align: "right" });

  currentY += 15;
  doc.line(20, currentY, pageWidth - 20, currentY);
  currentY += 10;

  // Terms
  doc.setFont("helvetica", "bold");
  doc.setFontSize(11);
  doc.text("Terms & Conditions:", 20, currentY);
  currentY += 7;
  doc.setFont("helvetica", "normal");
  doc.setFontSize(10);
  doc.text("• Follow up with extended services.", 25, currentY);
  currentY += 6;
  doc.text("• Quotation validity only for 60 days.", 25, currentY);
  currentY += 6;
  doc.text("• Please note that prices are subject to change according to fluctuating foreign currency rates.", 25, currentY);

  // Footer
  const pageHeight = doc.internal.pageSize.getHeight();
  // doc.setTextColor(0, 0, 0);
  // doc.setFont("helvetica", "bold");
  // doc.setFontSize(12);
  // doc.text("Southern rehab care", pageWidth / 2, pageHeight - 45, { align: "center" });
  // doc.setFont("helvetica", "normal");
  // doc.setFontSize(10);
  // doc.text("Hirimbura Rd, Karapitiya", pageWidth / 2, pageHeight - 40, { align: "center" });
  // doc.text("Tel: 0777439610 / 0714476402", pageWidth / 2, pageHeight - 35, { align: "center" });
  doc.setFontSize(9);
  doc.setTextColor(100, 100, 100);
  doc.text("This is a computer-generated quotation - no signature required", pageWidth / 2, pageHeight - 28, { align: "center" });

  // Footer Bar
  doc.setFillColor(2, 135, 46);
  doc.rect(0, pageHeight - 15, pageWidth, 15, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.setTextColor(255, 255, 255);
  doc.text("Registered Office: 90/8E, Anagarika Darmapala mw, Karapitiya, Galle | (Reg no: 1/14/80/2018-12-18/13)",
         pageWidth / 2, pageHeight - 7, { align: "center" });

  doc.save(`Quotation_${quotationData.quotationNo}.pdf`);
};



// Export all quotations to CSV
const handleExportQuotations = () => {
  const headers = ['Quotation No', 'Patient Name', 'Phone No', 'Date', 'Product', 'Description', 'Amount', 'Status'];
  
  const csvData = filteredQuotations.map(q => [
    q.quotationNo,
    q.to,
    q.patientPhoneNo,
    q.date,
    q.product,
    q.description,
    q.amount,
    q.status || 'active'
  ]);

  const csvContent = [
    headers.join(','),
    ...csvData.map(row => row.map(cell => `"${cell}"`).join(','))
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `quotations_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};







// Add these state variables for appointments
const [appointmentCategory, setAppointmentCategory] = useState("consultation"); // "consultation" or "measurement"
const [appointmentDate, setAppointmentDate] = useState("");
const [appointmentTime, setAppointmentTime] = useState("");
const [appointmentRemark, setAppointmentRemark] = useState("");
const [patientName, setPatientName] = useState("");
const [patientContact, setPatientContact] = useState("");
const [patientGender, setPatientGender] = useState("male");
const [patientAge, setPatientAge] = useState("");
const [appointmentStatus, setAppointmentStatus] = useState("scheduled");
const [isSubmitting, setIsSubmitting] = useState(false);

// Handle create appointment
const handleCreateAppointment = async () => {
  if (!patientName || !patientContact || !appointmentDate || !appointmentTime) {
    window.alert("Please fill in all required fields!");
    return;
  }

  setIsSubmitting(true);
  try {
    const appointmentData = {
      category: appointmentCategory,
      appointmentType: appointmentCategory === "consultation" 
        ? "Consultation Appointment" 
        : "Measurements & Fit-On Appointment",
      patientName: String(patientName).trim(),
      patientContact: String(patientContact).trim(),
      patientGender: patientGender,
      patientAge: patientAge ? parseInt(patientAge) : null,
      date: appointmentDate,
      time: appointmentTime,
      remark: String(appointmentRemark).trim(),
      status: appointmentStatus,
      createdAt: new Date(),
      updatedAt: new Date(),
    };

    await addDoc(collection(db, "appointments"), appointmentData);
    
    window.alert("Appointment created successfully!");
    
    // Reset form
    setAppointmentCategory("consultation");
    setAppointmentDate("");
    setAppointmentTime("");
    setAppointmentRemark("");
    setPatientName("");
    setPatientContact("");
    setPatientGender("male");
    setPatientAge("");
    setAppointmentStatus("scheduled");
    
  } catch (error) {
    console.error("Error creating appointment: ", error);
    window.alert("Failed to create appointment. Please try again.");
  } finally {
    setIsSubmitting(false);
  }
};

// Shift appointment to other category
const handleShiftToConsultation = () => {
  if (!patientName || !patientContact || !appointmentDate || !appointmentTime) {
    window.alert("Please fill in patient details, date and time first!");
    return;
  }
  setAppointmentCategory("consultation");
};

const handleShiftToMeasurement = () => {
  if (!patientName || !patientContact || !appointmentDate || !appointmentTime) {
    window.alert("Please fill in patient details, date and time first!");
    return;
  }
  setAppointmentCategory("measurement");
};









///////////////////////////////////// view all appointments ////////////////////////////////////////
// Add these with your other useState declarations
const [appointments, setAppointments] = useState([]);
const [filteredAppointments, setFilteredAppointments] = useState([]);
const [appointmentSearchTerm, setAppointmentSearchTerm] = useState("");
const [appointmentMonthFilter, setAppointmentMonthFilter] = useState("");
const [appointmentStartDate, setAppointmentStartDate] = useState("");
const [appointmentEndDate, setAppointmentEndDate] = useState("");
const [appointmentCategoryFilter, setAppointmentCategoryFilter] = useState("");
const [appointmentStatusFilter, setAppointmentStatusFilter] = useState("");
const [appointmentsLoading, setAppointmentsLoading] = useState(true);


// ============ FUNCTION CODES FOR VIEW ALL APPOINTMENTS ============

// Fetch appointments from Firebase
useEffect(() => {
  const fetchAppointments = async () => {
    setAppointmentsLoading(true);
    try {
      const appointmentsRef = collection(db, "appointments");
      const q = query(appointmentsRef, orderBy("createdAt", "desc"));
      const querySnapshot = await getDocs(q);
      
      const appointmentsList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      
      setAppointments(appointmentsList);
      setFilteredAppointments(appointmentsList);
    } catch (error) {
      console.error("Error fetching appointments: ", error);
    } finally {
      setAppointmentsLoading(false);
    }
  };

  fetchAppointments();
}, []);

// Filter appointments based on search, filters, and date range
useEffect(() => {
  let filtered = [...appointments];

  // Search filter
  if (appointmentSearchTerm) {
    filtered = filtered.filter(appointment => 
      appointment.patientName?.toLowerCase().includes(appointmentSearchTerm.toLowerCase()) ||
      appointment.patientContact?.includes(appointmentSearchTerm) ||
      appointment.appointmentType?.toLowerCase().includes(appointmentSearchTerm.toLowerCase()) ||
      appointment.remark?.toLowerCase().includes(appointmentSearchTerm.toLowerCase())
    );
  }

  // Category filter
  if (appointmentCategoryFilter) {
    filtered = filtered.filter(appointment => 
      appointment.category === appointmentCategoryFilter
    );
  }

  // Status filter
  if (appointmentStatusFilter) {
    filtered = filtered.filter(appointment => 
      appointment.status === appointmentStatusFilter
    );
  }

  // Month filter
  if (appointmentMonthFilter) {
    filtered = filtered.filter(appointment => {
      if (!appointment.date) return false;
      const [year, month] = appointment.date.split('-');
      return month === appointmentMonthFilter;
    });
  }

  // Date range filter
  if (appointmentStartDate && appointmentEndDate) {
    filtered = filtered.filter(appointment => {
      if (!appointment.date) return false;
      return appointment.date >= appointmentStartDate && appointment.date <= appointmentEndDate;
    });
  } else if (appointmentStartDate) {
    filtered = filtered.filter(appointment => appointment.date >= appointmentStartDate);
  } else if (appointmentEndDate) {
    filtered = filtered.filter(appointment => appointment.date <= appointmentEndDate);
  }

  setFilteredAppointments(filtered);
}, [appointmentSearchTerm, appointmentCategoryFilter, appointmentStatusFilter, appointmentMonthFilter, appointmentStartDate, appointmentEndDate, appointments]);

// Handle delete appointment
const handleDeleteAppointment = async (id) => {
  if (window.confirm("Are you sure you want to delete this appointment?")) {
    try {
      await deleteDoc(doc(db, "appointments", id));
      setAppointments(appointments.filter(apt => apt.id !== id));
      setFilteredAppointments(filteredAppointments.filter(apt => apt.id !== id));
      window.alert("Appointment deleted successfully!");
    } catch (error) {
      console.error("Error deleting appointment: ", error);
      window.alert("Failed to delete appointment. Please try again.");
    }
  }
};

// Handle update appointment status
const handleUpdateStatus = async (id, newStatus) => {
  try {
    await updateDoc(doc(db, "appointments", id), {
      status: newStatus,
      updatedAt: new Date()
    });
    
    // Update local state
    setAppointments(appointments.map(apt => 
      apt.id === id ? { ...apt, status: newStatus } : apt
    ));
    setFilteredAppointments(filteredAppointments.map(apt => 
      apt.id === id ? { ...apt, status: newStatus } : apt
    ));
    
    window.alert(`Appointment status updated to ${newStatus}`);
  } catch (error) {
    console.error("Error updating appointment status: ", error);
    window.alert("Failed to update status. Please try again.");
  }
};

// Export appointments to CSV
const handleExportAppointments = () => {
  const headers = ['Patient Name', 'Contact', 'Gender', 'Age', 'Appointment Type', 'Date', 'Time', 'Remarks', 'Status', 'Created At'];
  
  const csvData = filteredAppointments.map(apt => [
    apt.patientName,
    apt.patientContact,
    apt.patientGender,
    apt.patientAge || 'N/A',
    apt.appointmentType,
    apt.date,
    apt.time,
    apt.remark || 'N/A',
    apt.status,
    apt.createdAt ? new Date(apt.createdAt.toDate()).toLocaleDateString() : 'N/A'
  ]);

  const csvContent = [
    headers.join(','),
    ...csvData.map(row => row.map(cell => `"${cell}"`).join(','))
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', `appointments_${new Date().toISOString().split('T')[0]}.csv`);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

// Clear all filters
const handleClearFilters = () => {
  setAppointmentSearchTerm("");
  setAppointmentCategoryFilter("");
  setAppointmentStatusFilter("");
  setAppointmentMonthFilter("");
  setAppointmentStartDate("");
  setAppointmentEndDate("");
};

// Get today's appointments
const getTodaysAppointments = () => {
  const today = new Date().toISOString().split('T')[0];
  return appointments.filter(apt => apt.date === today);
};

// Get upcoming appointments (next 7 days)
const getUpcomingAppointments = () => {
  const today = new Date();
  const nextWeek = new Date();
  nextWeek.setDate(today.getDate() + 7);
  
  const todayStr = today.toISOString().split('T')[0];
  const nextWeekStr = nextWeek.toISOString().split('T')[0];
  
  return appointments.filter(apt => {
    return apt.date >= todayStr && apt.date <= nextWeekStr && 
           (apt.status === 'scheduled' || apt.status === 'confirmed');
  });
};

// Print appointment list
const handlePrintAppointments = () => {
  const printWindow = window.open('', '_blank');
  printWindow.document.write(`
    <html>
      <head>
        <title>Appointments List</title>
        <style>
          body { font-family: Arial, sans-serif; margin: 20px; }
          h1 { color: #00b13c; text-align: center; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th { background: #333; color: white; padding: 10px; text-align: left; }
          td { padding: 8px; border-bottom: 1px solid #ddd; }
          .status { padding: 4px 8px; border-radius: 4px; }
          .scheduled { background: #fff3cd; color: #856404; }
          .confirmed { background: #d4edda; color: #155724; }
          .completed { background: #cce5ff; color: #004085; }
          .cancelled { background: #f8d7da; color: #721c24; }
        </style>
      </head>
      <body>
        <h1>Appointments List</h1>
        <p>Generated on: ${new Date().toLocaleDateString()}</p>
        <table>
          <thead>
            <tr>
              <th>Patient Name</th>
              <th>Contact</th>
              <th>Type</th>
              <th>Date</th>
              <th>Time</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            ${filteredAppointments.map(apt => `
              <tr>
                <td>${apt.patientName}</td>
                <td>${apt.patientContact}</td>
                <td>${apt.appointmentType}</td>
                <td>${apt.date}</td>
                <td>${apt.time}</td>
                <td><span class="status ${apt.status}">${apt.status}</span></td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </body>
    </html>
  `);
  printWindow.document.close();
  printWindow.print();
};

// Bulk status update
const handleBulkStatusUpdate = async (status) => {
  if (!filteredAppointments.length) {
    window.alert("No appointments to update");
    return;
  }

  if (window.confirm(`Are you sure you want to update all ${filteredAppointments.length} appointments to ${status}?`)) {
    try {
      const batch = writeBatch(db);
      
      filteredAppointments.forEach(apt => {
        const aptRef = doc(db, "appointments", apt.id);
        batch.update(aptRef, { 
          status: status,
          updatedAt: new Date() 
        });
      });
      
      await batch.commit();
      
      // Update local state
      const updatedAppointments = appointments.map(apt => 
        filteredAppointments.some(fApt => fApt.id === apt.id) 
          ? { ...apt, status: status } 
          : apt
      );
      
      setAppointments(updatedAppointments);
      setFilteredAppointments(updatedAppointments.filter(apt => 
        filteredAppointments.some(fApt => fApt.id === apt.id)
      ));
      
      window.alert(`Successfully updated ${filteredAppointments.length} appointments to ${status}`);
    } catch (error) {
      console.error("Error in bulk status update: ", error);
      window.alert("Failed to update appointments. Please try again.");
    }
  }
};





return (

    <div className="hero-dashboard-container">
      {/* Left Sidebar */}
      <div className="lecturer-sidebar">
      <div className="home-content">
              <img
                src="/round-logo.png" 
                alt="Southern Rehab Care"
              
              />
              </div>
        <h2 className="lecturer-sidebar-title">Southern Rehab Care</h2>

        <div className="lecturer-sidebar-list">
        <li onClick={() => setSelectedOption("addPatient")}>Add Patient</li>
        <li onClick={() => setSelectedOption("viewPatients")}>View All Patients</li>
        <li onClick={() => setSelectedOption("createQuotation")}>Create Quotation</li>
        <li onClick={() => setSelectedOption("viewAllQuotation")}>View All Quotation</li>
        <li onClick={() => setSelectedOption("createInvoice")}>Create Invoice</li>
        <li onClick={() => setSelectedOption("settleInvoice")}>Create Settle Invoice</li>
        <li onClick={() => setSelectedOption("viewInvoice")}>View All Previous Invoice</li>
        <li onClick={() => setSelectedOption("viewallsettleInvoice")}>View All Settlement Invoice</li>
        <li onClick={() => setSelectedOption("createAppointment")}>Create Appointment</li>
        <li onClick={() => setSelectedOption("viewAllAppointment")}>View All Appointment</li>
        <li onClick={() => setSelectedOption("notification")}>Patient Follow-Ups</li>
        <li onClick={() => setSelectedOption("salesReport")}>Sales Report</li>
        <li className="logout-button" onClick={handleLogout}>Logout</li>
        </div>
      </div>

      {/* Main Panel */}
      <div className="lecturer-panel">






{/********************************************Create Appointment**************************************************************************/}




{selectedOption === "createAppointment" && (
  <div className="appointment-create-container">
    <h1 className="appointment-create-heading">Create Appointment</h1>
    
    <div className="appointment-create-form">
      {/* Category Selection Cards */}
      <div className="appointment-category-selector">
        <div 
          className={`appointment-category-card appointment-consultation ${appointmentCategory === "consultation" ? "active" : ""}`}
          onClick={() => setAppointmentCategory("consultation")}
        >
          <div className="appointment-category-icon">👨‍⚕️</div>
          <div className="appointment-category-title">Consultation</div>
          <div className="appointment-category-desc">
            Initial consultation with specialist
          </div>
          {appointmentCategory === "consultation" && (
            <div className="appointment-active-badge">Selected</div>
          )}
        </div>
        
        <div 
          className={`appointment-category-card appointment-measurement ${appointmentCategory === "measurement" ? "active" : ""}`}
          onClick={() => setAppointmentCategory("measurement")}
        >
          <div className="appointment-category-icon">📏</div>
          <div className="appointment-category-title">Measurements & Fit-On</div>
          <div className="appointment-category-desc">
            Measurements and fitting session
          </div>
          {appointmentCategory === "measurement" && (
            <div className="appointment-active-badge">Selected</div>
          )}
        </div>
      </div>

      {/* Shift Buttons */}
      <div className="appointment-shift-buttons">
        <button 
          onClick={handleShiftToConsultation}
          className="appointment-shift-button appointment-consultation"
          disabled={appointmentCategory === "consultation"}
        >
          ← Shift to Consultation
        </button>
        <button 
          onClick={handleShiftToMeasurement}
          className="appointment-shift-button appointment-measurement"
          disabled={appointmentCategory === "measurement"}
        >
          Shift to Measurements & Fit-On →
        </button>
      </div>

      {/* Patient Details Section */}
      <div className="appointment-form-section">
        <h3>Patient Details</h3>
        <div className="appointment-form-row">
          <div className="appointment-form-group">
            <label>Patient Name <span>*</span></label>
            <input
              type="text"
              value={patientName}
              onChange={(e) => setPatientName(e.target.value)}
              placeholder="Enter full name"
              required
            />
          </div>
          
          <div className="appointment-form-group">
            <label>Contact Number <span>*</span></label>
            <input
              type="tel"
              value={patientContact}
              onChange={(e) => setPatientContact(e.target.value)}
              placeholder="07X XXX XXXX"
              required
            />
          </div>
        </div>
        
        <div className="appointment-form-row">
          <div className="appointment-form-group">
            <label>Gender</label>
            <div className="appointment-gender-options">
              <label className="appointment-gender-option">
                <input
                  type="radio"
                  value="male"
                  checked={patientGender === "male"}
                  onChange={(e) => setPatientGender(e.target.value)}
                />
                Male
              </label>
              <label className="appointment-gender-option">
                <input
                  type="radio"
                  value="female"
                  checked={patientGender === "female"}
                  onChange={(e) => setPatientGender(e.target.value)}
                />
                Female
              </label>
              <label className="appointment-gender-option">
                <input
                  type="radio"
                  value="other"
                  checked={patientGender === "other"}
                  onChange={(e) => setPatientGender(e.target.value)}
                />
                Other
              </label>
            </div>
          </div>
          
          <div className="appointment-form-group">
            <label>Age</label>
            <input
              type="number"
              value={patientAge}
              onChange={(e) => setPatientAge(e.target.value)}
              placeholder="Enter age"
              min="0"
              max="150"
            />
          </div>
        </div>
      </div>

      {/* Appointment Details Section */}
      <div className="appointment-form-section">
        <h3>Appointment Details</h3>
        <div className="appointment-datetime-row">
          <div className="appointment-form-group">
            <label>Date <span>*</span></label>
            <input
              type="date"
              value={appointmentDate}
              onChange={(e) => setAppointmentDate(e.target.value)}
              min={new Date().toISOString().split('T')[0]}
              required
            />
          </div>
          
          <div className="appointment-form-group">
            <label>Time <span>*</span></label>
            <input
              type="time"
              value={appointmentTime}
              onChange={(e) => setAppointmentTime(e.target.value)}
              required
            />
          </div>
        </div>
        
        <div className="appointment-form-group">
          <label>Remarks</label>
          <textarea
            value={appointmentRemark}
            onChange={(e) => setAppointmentRemark(e.target.value)}
            placeholder="Any special notes or requirements..."
            rows="4"
            className="appointment-textarea"
          />
        </div>
      </div>

      {/* Status Selection */}
      <div className="appointment-form-section">
        <h3>Status</h3>
        <div className="appointment-form-group">
          <select
            value={appointmentStatus}
            onChange={(e) => setAppointmentStatus(e.target.value)}
          >
            <option value="scheduled">Scheduled</option>
            <option value="confirmed">Confirmed</option>
            <option value="pending">Pending</option>
            <option value="cancelled">Cancelled</option>
            <option value="completed">Completed</option>
          </select>
        </div>
      </div>

      {/* Create Button */}
      <button 
        onClick={handleCreateAppointment}
        className="appointment-create-button"
        disabled={isSubmitting}
      >
        {isSubmitting ? "Creating..." : "Create Appointment"}
      </button>
    </div>
  </div>
)}















{/********************************************View all appointments**************************************************************************/}

{selectedOption === "viewAllAppointment" && (
  <div className="appointment-view-container">
    <h1 className="appointment-view-heading">View All Appointments</h1>

    {/* Statistics Cards */}
    <div className="appointment-stat-cards">
      <div className="appointment-stat-card">
        <div className="appointment-stat-number">{appointments.length}</div>
        <div className="appointment-stat-label">Total Appointments</div>
      </div>
      <div className="appointment-stat-card">
        <div className="appointment-stat-number">
          {appointments.filter(apt => apt.status === "scheduled" || apt.status === "confirmed").length}
        </div>
        <div className="appointment-stat-label">Upcoming</div>
      </div>
      <div className="appointment-stat-card">
        <div className="appointment-stat-number">
          {appointments.filter(apt => apt.status === "completed").length}
        </div>
        <div className="appointment-stat-label">Completed</div>
      </div>
      <div className="appointment-stat-card">
        <div className="appointment-stat-number">
          {appointments.filter(apt => apt.category === "consultation").length}
        </div>
        <div className="appointment-stat-label">Consultations</div>
      </div>
      <div className="appointment-stat-card">
        <div className="appointment-stat-number">
          {appointments.filter(apt => apt.category === "measurement").length}
        </div>
        <div className="appointment-stat-label">Measurements</div>
      </div>
    </div>

    {/* Filters Header */}
    <div className="appointment-filters-header">
      <div className="appointment-filters-left">
        <select
          value={appointmentCategoryFilter}
          onChange={(e) => setAppointmentCategoryFilter(e.target.value)}
          className="appointment-filter-select"
        >
          <option value="">All Categories</option>
          <option value="consultation">Consultation</option>
          <option value="measurement">Measurements & Fit-On</option>
        </select>

        <select
          value={appointmentStatusFilter}
          onChange={(e) => setAppointmentStatusFilter(e.target.value)}
          className="appointment-filter-select"
        >
          <option value="">All Status</option>
          <option value="scheduled">Scheduled</option>
          <option value="confirmed">Confirmed</option>
          <option value="pending">Pending</option>
          <option value="completed">Completed</option>
          <option value="cancelled">Cancelled</option>
        </select>

        <select
          value={appointmentMonthFilter}
          onChange={(e) => setAppointmentMonthFilter(e.target.value)}
          className="appointment-filter-select"
        >
          <option value="">All Months</option>
          <option value="01">January</option>
          <option value="02">February</option>
          <option value="03">March</option>
          <option value="04">April</option>
          <option value="05">May</option>
          <option value="06">June</option>
          <option value="07">July</option>
          <option value="08">August</option>
          <option value="09">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>

        <input
          type="date"
          value={appointmentStartDate}
          onChange={(e) => setAppointmentStartDate(e.target.value)}
          className="appointment-filter-date"
          placeholder="Start Date"
        />

        <input
          type="date"
          value={appointmentEndDate}
          onChange={(e) => setAppointmentEndDate(e.target.value)}
          className="appointment-filter-date"
          placeholder="End Date"
        />
      </div>

      <div className="appointment-filters-right">
        <input
          type="text"
          placeholder="Search by name, contact, remarks..."
          className="appointment-search-input"
          value={appointmentSearchTerm}
          onChange={(e) => setAppointmentSearchTerm(e.target.value)}
        />

        <button 
          onClick={handleExportAppointments} 
          className="appointment-export-button"
        >
          Export CSV
        </button>
      </div>
    </div>

    {/* Appointments Table */}
    <div className="appointment-table-container">
      {appointmentsLoading ? (
        <div className="appointment-loading">Loading appointments...</div>
      ) : (
        <table className="appointment-table">
          <thead>
            <tr>
              <th>Patient Name</th>
              <th>Contact</th>
              <th>Gender/Age</th>
              <th>Appointment Type</th>
              <th>Date</th>
              <th>Time</th>
              <th>Remarks</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredAppointments.length > 0 ? (
              filteredAppointments.map((appointment) => (
                <tr key={appointment.id}>
                  <td>{appointment.patientName}</td>
                  <td>{appointment.patientContact}</td>
                  <td>
                    {appointment.patientGender} / {appointment.patientAge || 'N/A'}
                  </td>
                  <td>
                    <span className={`appointment-type-badge appointment-type-${appointment.category}`}>
                      {appointment.appointmentType}
                    </span>
                  </td>
                  <td>{appointment.date}</td>
                  <td>{appointment.time}</td>
                  <td>{appointment.remark || '-'}</td>
                  <td>
                    <select
                      value={appointment.status}
                      onChange={(e) => handleUpdateStatus(appointment.id, e.target.value)}
                      className={`appointment-status-badge appointment-status-${appointment.status}`}
                      style={{ padding: '4px 8px', borderRadius: '4px' }}
                    >
                      <option value="scheduled">Scheduled</option>
                      <option value="confirmed">Confirmed</option>
                      <option value="pending">Pending</option>
                      <option value="completed">Completed</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </td>
                  <td>
                    <div className="appointment-actions">
                      <button 
                        className="appointment-delete-button"
                        onClick={() => handleDeleteAppointment(appointment.id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="appointment-no-data">
                  No appointments found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )}
    </div>
  </div>
)}







{/********************************************Create Quotation**************************************************************************/}

{selectedOption === "createQuotation" && (
  <div className="create-invoice-dashboard-container">
    <div className="lecturer-panel">
      <div className="create-invoice-section">
        <h1 className="invoice-heading">Create Quotation</h1>

        <form className="invoice-form">
          {/* Quotation Number - Uneditable */}
          <div className="form-section">
            <h3>Quotation Information</h3>
            <div className="form-column-create-invoice">
              <label htmlFor="quotationNo">Quotation No</label>
              <input
                type="text"
                id="quotationNo"
                value={quotationNumber}
                readOnly
                disabled
                style={{
                  backgroundColor: '#f5f5f5',
                  cursor: 'not-allowed',
                  color: '#333',
                  fontWeight: 'bold'
                }}
                required
              />
              <small style={{color: '#666', fontSize: '12px', marginTop: '4px'}}>
                Quotation number is auto-generated and cannot be edited
              </small>
            </div>
          </div>

          {/* Patient Details */}
          <div className="form-section">
            <h3>Patient Details</h3>
            <div className="form-row-create-invoice">
              <div className="form-column-create-invoice">
                <label htmlFor="quotationTo">Patient Name</label>
                <input
                  type="text"
                  id="quotationTo"
                  value={quotationTo}
                  onChange={(e) => setQuotationTo(e.target.value)}
                  required
                />
              </div>

              <div className="form-column-create-invoice">
                <label htmlFor="quotationPatientPhoneNo">Patient's Phone No</label>
                <input
                  type="text"
                  id="quotationPatientPhoneNo"
                  value={quotationPatientPhoneNo}
                  onChange={(e) => setQuotationPatientPhoneNo(e.target.value)}
                  required
                />
              </div>

              <div className="form-column-create-invoice">
                <label htmlFor="quotationDate">Date</label>
                <input
                  type="date"
                  id="quotationDate"
                  value={quotationDate}
                  onChange={(e) => setQuotationDate(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          {/* Product Selection Dropdown */}
          <div className="form-section">
            <h3>Product Selection</h3>
            <div className="form-column-create-invoice">
              <label htmlFor="quotationProduct">Select Product <span style={{color: '#00b13c'}}>*</span></label>
              <select
                id="quotationProduct"
                value={quotationSelectedProduct}
                onChange={(e) => setQuotationSelectedProduct(e.target.value)}
                required
                style={{width: '100%', padding: '10px'}}
              >
                <option value="">-- Select Product --</option>
                {PRODUCT_OPTIONS.map((product) => (
                  <option key={product} value={product}>
                    {product}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {/* Description */}
          <div className="form-row-create-invoice">
            <div className="form-column-create-invoice col-span-2">
              <label htmlFor="quotationDescription">Description</label>
              <textarea
                id="quotationDescription"
                value={quotationDescription}
                onChange={(e) => setQuotationDescription(e.target.value)}
                rows="3"
              />
            </div>
          </div>

          {/* Amount Section */}
          <div className="form-section">
            <h3>Quotation Details</h3>
            <div className="form-row-create-invoice">
              <div className="form-column-create-invoice">
                <label htmlFor="quotationAmount">Amount (Rs.)</label>
                <input
                  type="number"
                  id="quotationAmount"
                  value={quotationAmount}
                  onChange={(e) => setQuotationAmount(e.target.value)}
                  required
                />
              </div>
            </div>
          </div>

          <button type="button" onClick={handleCreateQuotation} className="create-button">
            Create Quotation
          </button>
        </form>
      </div>
    </div>
  </div>
)}


{/************************************************* View All Quotation *********************************************************************/}


{selectedOption === "viewAllQuotation" && (
  <div className="quotation-container">

    <h1 className="quotation-heading">View All Quotations</h1>

    <div className="quotation-header">

      {/* Filters */}
      <div className="quotation-filters">

        <select
          value={monthFilter}
          onChange={(e) => setMonthFilter(e.target.value)}
          className="quotation-filter-select"
        >
          <option value="">All Months</option>
          <option value="01">January</option>
          <option value="02">February</option>
          <option value="03">March</option>
          <option value="04">April</option>
          <option value="05">May</option>
          <option value="06">June</option>
          <option value="07">July</option>
          <option value="08">August</option>
          <option value="09">September</option>
          <option value="10">October</option>
          <option value="11">November</option>
          <option value="12">December</option>
        </select>

        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="quotation-filter-date"
        />

        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="quotation-filter-date"
        />

      </div>

      {/* Search + Export */}
      <div className="quotation-actions">

        <input
          type="text"
          placeholder="Search by name, quotation no, or product..."
          className="quotation-search"
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
        />

        <button
          onClick={handleExportQuotations}
          className="quotation-export-btn"
        >
          Export All Quotations
        </button>

      </div>

    </div>

    {/* Table Section */}
    <div className="quotation-table-container">

      {loading ? (
        <div className="quotation-loading">
          Loading quotations...
        </div>
      ) : (
        <table className="quotation-table">

          <thead>
            <tr>
              <th>Quotation No</th>
              <th>Patient Name</th>
              <th>Phone No</th>
              <th>Date</th>
              <th>Product</th>
              <th>Description</th>
              <th>Amount (Rs.)</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {filteredQuotations.length > 0 ? (
              filteredQuotations.map((quotation) => (

                <tr key={quotation.id}>

                  <td>{quotation.quotationNo}</td>

                  <td>{quotation.to}</td>

                  <td>{quotation.patientPhoneNo || '-'}</td>

                  <td>{quotation.date}</td>

                  <td>{quotation.product}</td>

                  <td>{quotation.description || '-'}</td>

                  <td>
                    Rs. {quotation.amount?.toFixed(2) || '0.00'}
                  </td>

                  <td>
                    <span
                      className={`quotation-status-badge ${
                        quotation.status === "expired"
                          ? "quotation-status-expired"
                          : "quotation-status-active"
                      }`}
                    >
                      {quotation.status || "active"}
                    </span>
                  </td>

                  <td>

                    <div className="quotation-action-buttons">

                      {/* Download PDF */}
                      <button
                        onClick={() => generateQuotationPDF(quotation)}
                        className="quotation-download-btn"
                        title="Download PDF"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M5 20h14v-2H5v2zm7-18v10l4-4h-3V2h-2v6h-3l4 4V2z"/>
                        </svg>
                      </button>

                      {/* Delete */}
                      <button
                        onClick={() => handleDeleteQuotation(quotation.id)}
                        className="quotation-delete-btn"
                        title="Delete Quotation"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          fill="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path d="M6 19c0 1.1.9 2 2 2h8c1.1 
                          0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 
                          1H5v2h14V4z"/>
                        </svg>
                      </button>

                    </div>

                  </td>

                </tr>

              ))
            ) : (

              <tr>
                <td colSpan="9" style={{ textAlign: "center", padding: "20px" }}>
                  No quotations found.
                </td>
              </tr>

            )}
          </tbody>

        </table>
      )}

    </div>

  </div>
)}



{/************************************************* View All settle Invoice *********************************************************************/}

{selectedOption === "viewallsettleInvoice" && (
        <div className="view-settle-invoice-container">
          <h1>View All Settled Invoices</h1>

          <div className="invoice-filters">
            <input placeholder="Invoice No" value={filterInvoiceNo} onChange={(e) => setFilterInvoiceNo(e.target.value)} />
            <input placeholder="Patient Name or Phone" value={filterPatient} onChange={(e) => setFilterPatient(e.target.value)} />
            <input placeholder="Year" value={filterYear} onChange={(e) => setFilterYear(e.target.value)} />
            <input placeholder="Month (01-12)" value={filterMonth} onChange={(e) => setFilterMonth(e.target.value)} />
            <input placeholder="Day (01-31)" value={filterDate} onChange={(e) => setFilterDate(e.target.value)} />

            <button onClick={() => {
              setFilterYear("");
              setFilterMonth("");
              setFilterDate("");
              setFilterInvoiceNo("");
              setFilterPatient("");
            }}>
              Clear Filters
            </button>
          </div>

          {loadingInvoices ? (
            <p>Loading invoices...</p>
          ) : (
            <table className="settle-invoice-table">
              <thead>
                <tr>
                  <th>Invoice No</th>
                  <th>Patient</th>
                  <th>Total</th>
             
                  <th>Settlements</th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {filteredSettleInvoices.map((inv) => (
                  <tr key={inv.invoiceNo}>
                    <td>{inv.invoiceNo}</td>
                    <td>{inv.to}</td>
                    <td>{inv.totalAmount}</td>
                  

<td className="white-text">
  {inv.settlements?.length > 0 ? (
    <ul>
      {inv.settlements.map((s, i) => (
        <li key={i}>
          {getSafeDate(s.date)?.toLocaleDateString()} | Paid: {s.paidAmount} | Balance: {s.newBalance}
        </li>
      ))}
    </ul>
  ) : (
    "No settlements"
  )}
</td>

                    <td>
                    
                      <button onClick={() => downloadSettlementInvoice(inv)}>Download</button>
                      <button className="set-delete-button" onClick={() => handleDeleteSettleInvoice(inv)}>Delete</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            
          )}



        </div>
      )}






{/**********************************************************************************************************************/}


{selectedOption === "settleInvoice" && (
  <div className="page-wrapper">
  <div className="settle-container">

    <h1 className="page-title">Balance Payable Invoice</h1>

    {/* Search Section */}
    <div className="card search-card">
      <h2 className="section-title">Search Invoice</h2>

      <div className="form-row">
        <div className="form-group">
          <label>Invoice Number</label>
          <input
            type="text"
            placeholder="Enter invoice number"
            value={searchInvoiceNo}
            onChange={(e) => setSearchInvoiceNo(e.target.value)}
          />
        </div>

        <button className="search-btn" onClick={searchInvoice}>
          Search
        </button>
      </div>
    </div>

    {/* Invoice Details After Search */}
    {foundInvoice && (
      <div className="card invoice-card">
        <h2 className="section-title">Invoice Details</h2>

        <div className="details-grid">
          <p><strong>Patient Name:</strong> {foundInvoice.to}</p>
          <p><strong>Remaining Balance:</strong> Rs. {foundInvoice.totalAmount.toFixed(2)}</p>
        </div>


<div className="form-group mt-15">
  <label>Settlement Date</label>
  <input
    type="date"
    value={settleDate}
    onChange={(e) => setSettleDate(e.target.value)}
  />
</div>


        <div className="form-group mt-15">
          <label>Amount Paying Now</label>
          <input
            type="number"
            placeholder="Enter amount"
            value={settleAmount}
            onChange={(e) => setSettleAmount(e.target.value)}
          />
        </div>

        <button className="pay-btn" onClick={handleSettlePayment}>
          Settle Now
        </button>
      </div>
    )}
  </div>
  </div>
)}





{/************************************************************************************************/}








{selectedOption === "salesReport" && (
  <div
    className="sales-container"
    style={{
      maxWidth: "1000px",
      width: "100%",
      margin: "0 auto",
      padding: "24px",
      background: "#fff",
      borderRadius: "10px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
      boxSizing: "border-box",
      fontFamily: '"Segoe UI", Roboto, sans-serif',
    }}
  >
    <h2 style={{ fontSize: "22px", fontWeight: "600", color: "#1f2937", marginBottom: "18px" }}>
      Sales Report
    </h2>

    {/* Filter Controls */}
    <div
      className="filter-controls"
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        alignItems: "center",
        marginBottom: "20px",
        width: "100%",
      }}
    >
      <select
        value={filterMode}
        onChange={(e) => setFilterMode(e.target.value)}
        style={{
          padding: "8px 12px",
          fontSize: "14px",
          borderRadius: "6px",
          border: "1px solid #d1d5db",
          outline: "none",
          color: "#111827",
          background: "#160361",
          minWidth: "160px",
        }}
      >
        <option value="daily">Daily</option>
        <option value="monthly">Monthly</option>
        <option value="yearly">Yearly</option>
      </select>

      {filterMode === "daily" && (
        <input
          type="date"
          value={selectedDate.format("YYYY-MM-DD")}
          onChange={(e) => setSelectedDate(dayjs(e.target.value))}
          style={{
            padding: "8px 12px",
            fontSize: "14px",
            borderRadius: "6px",
            border: "1px solid #d1d5db",
            outline: "none",
            color: "#111827",
            background: "#020352",
          }}
        />
      )}
      {filterMode === "monthly" && (
        <input
          type="month"
          value={selectedDate.format("YYYY-MM")}
          onChange={(e) => setSelectedDate(dayjs(e.target.value))}
          style={{
            padding: "8px 12px",
            fontSize: "14px",
            borderRadius: "6px",
            border: "1px solid #d1d5db",
            outline: "none",
            color: "#111827",
            background: "#fff",
          }}
        />
      )}
      {filterMode === "yearly" && (
        <input
          type="number"
          min="2000"
          max="2100"
          value={selectedDate.format("YYYY")}
          onChange={(e) => setSelectedDate(dayjs(`${e.target.value}-01-01`))}
          style={{
            padding: "8px 12px",
            fontSize: "14px",
            borderRadius: "6px",
            border: "1px solid #d1d5db",
            outline: "none",
            color: "#111827",
            background: "#fff",
          }}
        />
      )}

      {/* Download Buttons */}
      <div style={{ display: "flex", gap: "10px", marginLeft: "auto", marginBottom: "10px" }}>
        <button
          onClick={downloadSalesReportPDF}
          style={{
            padding: "8px 15px",
            backgroundColor: "#4a90e2",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Download PDF
        </button>
        <button
          onClick={downloadExcel}
          style={{
            padding: "8px 15px",
            backgroundColor: "#4caf50",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Download Excel
        </button>
      </div>
    </div>

    {/* Summary */}
    <div
      className="summary"
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: "12px",
        width: "100%",
        marginBottom: "20px",
      }}
    >
      <p style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px 14px", fontSize: "14px", color: "#374151" }}>
        Total {filterMode} Sale: <span style={{ display: "block", marginTop: "4px", fontSize: "16px", fontWeight: "600", color: "#111827" }}>Rs. {totalSale.toLocaleString()}</span>
      </p>
      <p style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px 14px", fontSize: "14px", color: "#374151" }}>
        Total {filterMode} Paid: <span style={{ display: "block", marginTop: "4px", fontSize: "16px", fontWeight: "600", color: "#111827" }}>Rs. {totalPaid.toLocaleString()}</span>
      </p>
      <p style={{ background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "8px", padding: "12px 14px", fontSize: "14px", color: "#374151" }}>
        Total {filterMode} Payable Balance: <span style={{ display: "block", marginTop: "4px", fontSize: "16px", fontWeight: "600", color: "#111827" }}>Rs. {totalPayable.toLocaleString()}</span>
      </p>
    </div>

    {/* Table */}
    <div style={{ overflowX: "auto" }}>
      <div className="sales-table-wrapper">
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13.5px", maxWidth: "1000px", margin: "0 auto" }}>
        <thead style={{ background: "#f3f4f6" }}>
          <tr>
            <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #d1d5db" }}>Date</th>
            <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #d1d5db" }}>Invoice No</th>
            <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #d1d5db" }}>Customer</th>
            <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #d1d5db" }}>Phone</th>
            <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #d1d5db" }}>Payment Method</th>
            <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #d1d5db" }}>Device Type</th>
            <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #d1d5db" }}>Full Price</th>
            <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #d1d5db" }}>Advanced</th>
            <th style={{ padding: "10px", textAlign: "left", borderBottom: "1px solid #d1d5db" }}>Payable Balance</th>
          </tr>
        </thead>
        <tbody>
          {filteredInvoices.length > 0 ? (
            filteredInvoices.map((inv) => {
              const payable = (inv.amount || 0) - (inv.deductAmount || 0);
              return (
                <tr key={inv.id} style={{ borderBottom: "1px solid #e5e7eb" }}>
                  <td style={{ padding: "9px 10px" }}>{inv.date}</td>
                  <td style={{ padding: "9px 10px" }}>{inv.invoiceNo}</td>
                  <td style={{ padding: "9px 10px" }}>{inv.to}</td>
                  <td style={{ padding: "9px 10px" }}>{inv.patientPhoneNo}</td>
                  <td style={{ padding: "9px 10px" }}>{inv.paymentMethod}</td>
                  <td style={{ padding: "9px 10px" }}>{inv.product}</td>
                  <td style={{ padding: "9px 10px" }}>Rs. {inv.amount}</td>
                  <td style={{ padding: "9px 10px" }}>Rs. {inv.deductAmount}</td>
                  <td style={{ padding: "9px 10px", fontWeight: "600", color: "#dc2626" }}>Rs. {payable}</td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="14" style={{ textAlign: "center", padding: "18px", color: "#6b7280", fontStyle: "italic" }}>
                No records found for this period.
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
    </div>
  </div>
)}






{/**********************************************************************************************************************/}





        {selectedOption === "addPatient" && (
          <div className="patient-form-question">
          <h1 className="lecturer-panel-title">Add Patient</h1>
          <form onSubmit={handleSubmit} className="patient-form-container">
            <div className="form-group">
              <label>Name:</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Date of Birth:</label>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
             
              />
            </div>

            <div className="form-group">
              <label>Sex:</label>
              {/* <select
                name="sex"
                value={formData.sex}
                onChange={handleChange}
                required
              >
                <option value="">Select Gender</option>
                <option value="male">Male</option>
                <option value="female">Female</option>
              </select> */}
              <select
                name="sex"
                value={formData.sex}
                onChange={handleChange}
                required
          
              >
                <option value="">Select Gender</option>
             
                <option    style={{ color: "black" }} value="male">Male</option>
                <option    style={{ color: "black" }} value="female">Female</option>
              </select>

            </div>

            <div className="form-group">
              <label>Telephone No:</label>
              <input
                type="tel"
                name="telephoneNo"
                value={formData.telephoneNo}
                onChange={handleChange}
          
              />
            </div>



            <div className="form-group">
              <label>Email:</label>
              <textarea
                name="email"
                value={formData.email}
                onChange={handleChange}

              />
            </div>

            <div className="form-group">
              <label>Address:</label>
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
           
              />
            </div>

            <button type="submit" className="submit-btn">Add Patient</button>
          </form>
        </div>
        )}






     


{/********************************************** create Invoice *********************************************************************/}



{selectedOption === "createInvoice" && userDetails && (
  <div className="create-invoice-dashboard-container">
    <div className="lecturer-panel">
      {selectedOption === "createInvoice" && userDetails && (
        <div className="create-invoice-section">
          <h1 className="invoice-heading">Create Invoice</h1>

   

          <form className="invoice-form">
            {/* Invoice Number */}
{/* Invoice Number - Now uneditable */}
<div className="form-section">
  <h3>Invoice Information</h3>
  <div className="form-column-create-invoice">
    <label htmlFor="invoiceNo">Invoice No</label>
    <input
      type="text"
      id="invoiceNo"
      value={invoiceNumber}
      readOnly // Make it uneditable
      disabled // Also disabled for better UX
      style={{
        backgroundColor: '#f5f5f5', // Light gray background to show it's disabled
        cursor: 'not-allowed',
        color: '#333',
        fontWeight: 'bold'
      }}
      required
    />
    <small style={{color: '#666', fontSize: '12px', marginTop: '4px'}}>
      Invoice number is auto-generated and cannot be edited
    </small>
  </div>
</div>

            {/* Patient Details */}
            <div className="form-section">
              <h3>Patient Details</h3>
              <div className="form-row-create-invoice">
                <div className="form-column-create-invoice">
                  <label htmlFor="to">Patient Name</label>
                  <input
                    type="text"
                    id="to"
                    value={to}
                    onChange={(e) => setTo(e.target.value)}
                    required
                  />
                </div>

                <div className="form-column-create-invoice">
                  <label htmlFor="patientPhoneNo">Patient's Phone No</label>
                  <input
                    type="text"
                    id="patientPhoneNo"
                    value={patientPhoneNo}
                    onChange={(e) => setPatientPhoneNo(e.target.value)}
                    required
                  />
                </div>

                <div className="form-column-create-invoice">
                  <label htmlFor="date">Date</label>
                  <input
                    type="date"
                    id="date"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    required
                  />
                </div>
              </div>
            </div>

            {/* NEW: Product Selection Dropdown */}
            <div className="form-section">
              <h3>Product Selection</h3>
              <div className="form-column-create-invoice">
                <label htmlFor="product">Select Product <span style={{color: '#00b13c'}}>*</span></label>
                <select
                  id="product"
                  value={selectedProduct}
                  onChange={(e) => setSelectedProduct(e.target.value)}
                  required
                  style={{width: '100%', padding: '10px'}}
                >
                  <option value="">-- Select Product --</option>
                  {PRODUCT_OPTIONS.map((product) => (
                    <option key={product} value={product}>
                      {product}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Description */}
            <div className="form-row-create-invoice">
              <div className="form-column-create-invoice col-span-2">
                <label htmlFor="description">Description</label>
                <textarea
                  id="description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows="3"
                />
              </div>
            </div>

            {/* Payment Section */}
            <div className="form-section">
              <h3>Payment Details</h3>
              <div className="form-row-create-invoice">
                <div className="form-column-create-invoice">
                  <label htmlFor="paymentMethod">Payment Method</label>
                  <select
                    id="paymentMethod"
                    value={paymentMethod}
                    onChange={(e) => setPaymentMethod(e.target.value)}
                    required
                  >
                    <option value="">-- Select Payment Method --</option>
                    <option value="Cash">Cash</option>
                    <option value="Card">Card</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Direct Deposit">Direct Deposit</option>
                  </select>
                </div>

                <div className="form-column-create-invoice">
                  <label htmlFor="amount">Amount</label>
                  <input
                    type="number"
                    id="amount"
                    value={amount}
                    onChange={(e) => {
                      const value = e.target.value;
                      setAmount(value);
                      setTotalAmount(parseFloat(value) - parseFloat(deductAmount) || 0);
                    }}
                    required
                  />
                </div>
              </div>

              <div className="form-row-create-invoice">
                <div className="form-column-create-invoice">
                  <label htmlFor="deductAmount">Advance Payment</label>
                  <input
                    type="number"
                    id="deductAmount"
                    value={deductAmount}
                    onChange={(e) => {
                      const value = e.target.value;
                      setDeductAmount(value);
                      setTotalAmount(parseFloat(amount) - parseFloat(value));
                    }}
                  />
                </div>

                <div className="form-column-create-invoice">
                  <label htmlFor="totalAmount">Balance Amount</label>
                  <input
                    type="text"
                    id="totalAmount"
                    value={totalAmount}
                    readOnly
                    style={{backgroundColor: '#f5f5f5', fontWeight: 'bold'}}
                  />
                </div>
              </div>
            </div>

            <button type="button" onClick={handleCreateInvoice} className="create-button">
              Create Invoice
            </button>
          </form>
        </div>
      )}
    </div>
  </div>
)}


{/****************************************************** view Invoice***********************************************************************/}


{selectedOption === "viewInvoice" && (
  <div className="home-section">
   <h1 className="view-all-invoice-heading">View All Invoices</h1>
    <div className="invoice-header-container">


<div className="invoice-filters">

  {/* Status Filter */}
  <select
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
    className="invoice-filter-select"
  >
    <option value="">All Status</option>
    <option value="Sent">Sent</option>
    <option value="Not Sent">Not Sent</option>
    <option value="Done">Done</option>
    <option value="Delivered">Delivered</option>
    <option value="Pending">Pending</option>
    <option value="Claim only">Claim only</option>
    <option value="Cancelled">Cancelled</option>
    <option value="Redo">Redo</option>
    <option value="OFTC">OFTC</option>
    <option value="Stop Work">Stop Work</option>
  </select>

  {/* Month Filter */}
  <select
    value={monthFilter}
    onChange={(e) => setMonthFilter(e.target.value)}
    className="invoice-filter-select"
  >
    <option value="">All Months</option>
    <option value="01">January</option>
    <option value="02">February</option>
    <option value="03">March</option>
    <option value="04">April</option>
    <option value="05">May</option>
    <option value="06">June</option>
    <option value="07">July</option>
    <option value="08">August</option>
    <option value="09">September</option>
    <option value="10">October</option>
    <option value="11">November</option>
    <option value="12">December</option>
  </select>

  {/* Date Range */}
  <input
    type="date"
    value={startDate}
    onChange={(e) => setStartDate(e.target.value)}
    className="invoice-filter-date"
  />

  <input
    type="date"
    value={endDate}
    onChange={(e) => setEndDate(e.target.value)}
    className="invoice-filter-date"
  />

</div>






   

      <div className="invoice-actions">
        <input
          type="text"
          placeholder="Search by name or invoice number..."
          className="invoice-search"
          onChange={(e) => setSearchTerm(e.target.value)}
          value={searchTerm}
        />

        <button onClick={handleDownload} className="export-button">
          Export All Invoices
        </button>

      </div>

    </div>

    <div className="invoices-container"> 
      <table className="invoices-table">
        <thead>
          <tr>
            <th>Invoice Number</th>
            <th>Patient Phone No</th>
            <th>To</th>
            <th>Date</th>
            <th>Status</th>
            <th>Device</th>
            <th>Payment Method</th>
            <th>Total Amount</th>
            <th>Advanced Payment</th>
            <th>Balance Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filteredInvoices.length > 0 ? (
            filteredInvoices.map((invoice) => (
              <tr key={invoice.id}>
                <td>{invoice.invoiceNo}</td>
                <td>{invoice.patientPhoneNo}</td>
                <td>{invoice.to}</td>
                <td>{invoice.date}</td>
                <td>{invoice.status}</td>
                <td>{invoice.product}</td>
                <td>{invoice.paymentMethod}</td>
                <td>{invoice.amount}</td>
                <td>{invoice.deductAmount}</td>
                <td>{invoice.totalAmount}</td>
     


                      <td>
                        <div className="invoice-actions-container">
         <td>
  <select
    value={invoice.status || "Pending"}
    onChange={(e) => handleStatusChange(invoice.id, e.target.value)}
    className={`status-select status-${invoice.status?.toLowerCase().replace(" ", "-")}`}
  >
    <option value="Sent">Sent</option>
    <option value="Not Sent">Not Sent</option>
    <option value="Done">Done</option>
    <option value="Delivered">Delivered</option>
    <option value="Pending">Pending</option>
    <option value="Claim only">Claim only</option>
    <option value="Cancelled">Cancelled</option>
    <option value="Redo">Redo</option>
    <option value="OFTC">OFTC</option>
    <option value="Stop Work">Stop Work</option>
  </select>
</td>

<button 
  onClick={() => generatePDF(invoice)}
  className="download-pdf-button"
>
  <span>
    {/* Download Icon */}
    <svg xmlns="http://www.w3.org/2000/svg" 
         width="20" height="20" 
         fill="currentColor" 
         viewBox="0 0 24 24">
      <path d="M5 20h14v-2H5v2zm7-18v10l4-4h-3V2h-2v6h-3l4 4V2z"/>
    </svg>
  </span>
</button>

<button 
  onClick={() => handleDeleteInvoice(invoice.id)}
  className="delete-button"
>
  <span>
    {/* Trash Icon */}
    <svg xmlns="http://www.w3.org/2000/svg" 
         width="20" height="20" 
         fill="currentColor" 
         viewBox="0 0 24 24">
      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/>
    </svg>
  </span>
</button>

                        </div>
                      </td>


              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No invoices found.</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  </div>
)}




{/*******************************************************************************************************************/}

              

{selectedOption === "viewPatients" && (
  <div className="patients-section">
    <div className="patients-header">
      <h1 className="lecturer-panel-title">View All Patients</h1>
      <button onClick={handleDownloadPatients} className="patients-excel">
          Export to Excel
        </button>
      <div className="patients-actions">

        <input
          type="text"
          placeholder="Search by name or phone..."
          className="patient-search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />


      </div>
    </div>

    {loading ? (
      <div className="loading-spinner">Loading...</div>
    ) : filteredPatients.length === 0 ? (
      <p className="no-patients">
        {searchTerm ? "No matching patients found" : "No patients found in the database"}
      </p>
    ) : (
      <div className="patients-table-container">
        <table className="patients-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Date of Birth</th>
              <th>Sex</th>
              <th>Telephone</th>
              <th>Email</th>
              <th>Follow Up Date</th>
              <th>Follow Up Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredPatients.map(patient => (
              <tr key={patient.id}>
                <td>{patient.name}</td>
                <td>{patient.dateOfBirth}</td>
                <td>{patient.sex}</td>
                <td>{patient.telephoneNo}</td>
                <td>{patient.email}</td>
                <td>{patient.followUpDate || "N/A"}</td>
                <td>{patient.followUpDescription}</td>
                <td>
                  <div className="patient-actions-container">
                    <button 
                      onClick={() => setEditingPatient(patient)}
                      className="edit-patient-btn"
                    >
                      Edit
                    </button>
                    <button 
                      onClick={() => handleDeletePatient(patient.id)}
                      className="delete-patient-btn"
                    >
                      Delete
                    </button>
                  </div>
                </td>


              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}

    {/* Edit Patient Modal */}
{editingPatient && (
  <div className="modal-overlay">
    <div className="edit-patient-modal">
      {/* Close Button */}
      <button
        className="modal-close-btn"
        onClick={() => setEditingPatient(null)}
        aria-label="Close modal"
      >
        ×
      </button>

      <h2>Edit Patient Details</h2>
      <form onSubmit={handleUpdatePatient}>
        <div className="form-group">
          <label>Name:</label>
          <input
            type="text"
            value={editingPatient.name || ""}
            onChange={(e) =>
              setEditingPatient({ ...editingPatient, name: e.target.value })
            }
            required
          />
        </div>

        <div className="form-group">
          <label>Follow Up Date:</label>
          <input
            type="date"
            value={editingPatient.followUpDate || ""}
            onChange={(e) =>
              setEditingPatient({ ...editingPatient, followUpDate: e.target.value })
            }
          />
        </div>

        <div className="form-group">
          <label>Follow Up Description:</label>
          <textarea
            value={editingPatient.followUpDescription || ""}
            onChange={(e) =>
              setEditingPatient({ ...editingPatient, followUpDescription: e.target.value })
            }
            rows="3"
          />
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="cancel-btn-patient"
            onClick={() => setEditingPatient(null)}
          >
            Cancel
          </button>
          <button type="submit" className="save-btn-patient">
            Save Changes
          </button>
        </div>
      </form>
    </div>
  </div>
)}
  </div>
)}





{/********************************************** Patient Follow-ups ******************************************************************/}


{/* Notification Panel */} 
{selectedOption === "notification" && (
<div className="notification-section-wrapper">
    <div className="notification-section">
      <div className="notification-header">
        <h3>Patient Follow-ups</h3>
      <p className="notification-subtitle">
        {todayCount > 0 
          ? `${todayCount} follow-up${todayCount > 1 ? 's' : ''} today`
          : 'No follow-ups today'}
      </p>
    </div>

    <div className="notification-divider"></div>

    {error && (
      <div className="notification-error">
        <p>Error: {error}</p>
      </div>
    )}

    {loading ? (
      <div className="loading-notifications">
        <p>Loading notifications...</p>
      </div>
    ) : notifications.length === 0 ? (
      <div className="empty-notifications">
        <p>⚠️ No upcoming follow-ups found</p>
      </div>
    ) : (
      <div className="notification-list">
        {notifications.map((item) => (
          <div
            key={item.id}
            className={`notification-item ${item.isToday ? 'today-item' : ''}`}
            style={{
              borderLeft: `4px solid ${getPriorityColor(item.followUpDate)}`
            }}
          >
            <div
              className="notification-avatar"
              style={{ backgroundColor: getPriorityColor(item.followUpDate) }}
            >
              {item.followUpDate.getDate()}
            </div>

            <div className="notification-content">
              <p className={`notification-title ${item.isToday ? 'today-title' : ''}`}>
                {item.patientName}
              </p>

              <p className="notification-date">Follow-up: {item.formattedDate}</p>

              {item.telephoneNo && (
                <p className="notification-notes">
                  📞 Tel: {item.telephoneNo}
                </p>
              )}

              {item.followUpDescription && (
                <p className="notification-notes">
                  📝 {item.followUpDescription}
                </p>
              )}

              {item.notes && (
                <p className="notification-notes">{item.notes}</p>
              )}
            </div>

            <div className="notification-extra">
              <p className="notification-days">
                {item.isToday 
                  ? 'TODAY' 
                  : `${item.daysDifference} days`}
              </p>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
  </div>
)}




             
           

      </div>
    </div>
  );
};

export default Body;
